document.addEventListener("DOMContentLoaded", function() {
    $(".towels-work-blocks .btn-text").click(function(e) {
      e.preventDefault();
      var target = $(this).attr("href");
      console.log(target);
        $('html, body').animate({
            scrollTop: $(target).offset().top - 100
        }, 10);
    });
  // Listen for the message from the iframe
window.addEventListener('message', function(event) {
  if (event.origin === 'https://pitchprint.io') {
    if (event.data.type === 'add-class') {
      document.querySelector('.om-holder.om-holder-fixed').classList.add(event.data.className);
    }
  }
}, false);
   var handleDisocunt = setInterval(toggleDiscount,1000);
if($("body").hasClass("template-cart")){
  setTimeout(function(){
    $(".docapp-cart-with-coupon-summary .docapp-coupon-input--input-container").attr("style","display:none !important;");
    $(".docapp-cart-with-coupon-summary .docapp-coupon-input--bean-container").attr("style","display:none !important;");
  },2200);
}
  function toggleDiscount(){
    console.log("discount==="+$(".docapp-cart-with-coupon-summary").length)
    if($(".docapp-cart-with-coupon-summary").length > 0){
        $(".docapp-cart-with-coupon-summary .docapp-coupon-input--input-container").attr("style","display:none !important;");
        $(".docapp-cart-with-coupon-summary .docapp-coupon-input--bean-container").attr("style","display:none !important;");
      clearInterval(handleDisocunt);
      $("body").on("click",".toggle-container", function(e){
        e.preventDefault();
        e.stopPropagation();
     if($(this).parents("#cart-drawer").length > 0){
          var $this = $(this).parents("#cart-drawer");
        }else{
          var $this = $(this).parents(".cartitems--container");
        }
      if($(this).hasClass("active")){       
        $this.find(".docapp-cart-with-coupon-summary .docapp-coupon-input--input-container").attr("style","display:none !important;");
        $this.find(".docapp-cart-with-coupon-summary .docapp-coupon-input--bean-container").attr("style","display:none !important;");
        $(this).removeClass("active");
      }else{
         $this.find(".docapp-cart-with-coupon-summary .docapp-coupon-input--input-container").attr("style","display:flex !important;");
          $this.find(".docapp-cart-with-coupon-summary .docapp-coupon-input--bean-container").attr("style","display:flex !important;");
        $(this).addClass("active");
      }
    return false;
  });
    }
  }
//*********  Free shiping text on pdp quantity discount start **********//
    var interval = setInterval(bulkprice, 1000);
    var Element = document.querySelector(".lower-svg-icontext");
    var titles = Element.getAttribute("lower-title");
    var svgIcon = Element.getAttribute("lower-svg");
    var Titlelink = Element.getAttribute("lower-link");
    function bulkprice() {
        var multiTierBreaks = document.querySelectorAll(".product.multi-tier-breaks");
        if (multiTierBreaks.length > 0) {
            var wrapper = document.querySelector(".multi-tier-wrapper");
            if (titles != '') {
                if (wrapper) {
                    var newDiv = document.createElement("div");
                    newDiv.classList.add("header", "svg");
                    var svgDiv = document.createElement("div");
                    svgDiv.classList.add("svg-intligems");
                    var svg = svgIcon;
                    svgDiv.innerHTML = svg;
                    if (Titlelink !== '') {
                        var link = document.createElement("a");
                        link.appendChild(svgDiv);
                        link.href = Titlelink;
                        var h4 = document.createElement("h4");
                        h4.classList.add("free-ship");
                        h4.style.margin = "0";
                        h4.textContent = titles;
                        link.appendChild(h4);
                        newDiv.appendChild(link);
                    } else {
                        var h4 = document.createElement("h4");
                        h4.classList.add("free-ship");
                        h4.style.margin = "0";
                        h4.textContent = titles;
                        newDiv.appendChild(svgDiv);
                        newDiv.appendChild(h4);
                    }
                    wrapper.parentNode.insertBefore(newDiv, wrapper.nextSibling);
                    clearInterval(interval);
                }
            } else {
                setTimeout(function() {
                    clearInterval(interval);
                }, 3000);
            }
        }
    }
//*********  Free shiping text on pdp quantity discount end **********//
});
// Back to previous page js start................
$(document).ready(function () {
  let historyList = JSON.parse(sessionStorage.getItem("historyList")) || [];
  historyList.push(window.location.href);
  sessionStorage.setItem("historyList", JSON.stringify(historyList));
  $("#go-back-jtpl").on("click", function (event) {
    event.preventDefault();
    var last_history_length = historyList.length - 2;
    var last_history = historyList[last_history_length];
    if (last_history == undefined && last_history !== null) {
      window.location.href =
        "https://www.microfiberwholesale.com/pages/keep-shopping?_ab=0&_fd=0&_sc=1&preview_theme_id=158865293347";
    } else {
      var con_last_history = last_history.toString();
      window.location.href = last_history;
    }
  });
});
/// Back to previous page js start..............
document.addEventListener('DOMContentLoaded', (event) => {
  $("body").on('change',".swatches-variant-images-square.product-options-style-select .cstm-option-values .option-value", function(event){
    $(".cstm-text-widget").hide();
    setTimeout(function(){
      checkAndAppend();
    },200);
  });
  function checkAndAppend() {
    var subscription_widget = document.getElementById('appstle_subscription_widget0');
    var add_to_cart = document.getElementsByClassName('product-form--atc');
   if($(".cstm-text-widget").length > 0){
     $(".cstm-text-widget").remove();
   }
   var widget_length = $("#appstle_subscription_widget0").length;
     console.log("widget_length"+widget_length)
    var iconHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd"
      clip-rule="evenodd" viewBox="0 0 512 512">
      <path fill="#3cb7fb" fill-rule="nonzero"
          d="M256 0c70.686 0 134.69 28.658 181.016 74.984C483.342 121.31 512 185.314 512 256c0 70.686-28.658 134.69-74.984 181.016C390.69 483.342 326.686 512 256 512c-70.686 0-134.69-28.658-181.016-74.984C28.658 390.69 0 326.686 0 256c0-70.686 28.658-134.69 74.984-181.016C121.31 28.658 185.314 0 256 0z" />
      <circle fill="#3cb7fb" cx="256" cy="256" r="226.536" />
      <path fill="#fff" fill-rule="nonzero"
                      d="M275.546 302.281c-.88 22.063-38.246 22.092-39.099-.007-3.779-37.804-13.444-127.553-13.136-163.074.312-10.946 9.383-17.426 20.99-19.898 3.578-.765 7.512-1.136 11.476-1.132 3.987.007 7.932.4 11.514 1.165 11.989 2.554 21.402 9.301 21.398 20.444l-.044 1.117-13.099 161.385zm-19.55 39.211c14.453 0 26.168 11.717 26.168 26.171 0 14.453-11.715 26.167-26.168 26.167s-26.171-11.714-26.171-26.167c0-14.454 11.718-26.171 26.171-26.171z" />
      </svg>
    `;
    var themesettings_newtext = `<p><strong>Save 5% and never run out of microfiber</strong> with our hassle-free autoship subscription service. Designed to save your time and money</p>`;
    var newText = ` <div class="cstm-text-widget" style="display:flex;">${iconHTML} ${themesettings_newtext }</div>`;
    if (widget_length > 0) {
      subscription_widget.insertAdjacentHTML('beforeend', newText);
      clearInterval(intervalId);
    }else{
      setTimeout(function(){
        clearInterval(intervalId);
      }, 3000);
    }
  }
  const interval = 1000;
  const intervalId = setInterval(checkAndAppend, interval);
});
  $("body").on('click', '.button-buy-scroll a', function(e){  
 e.preventDefault(); 
  var href = $(this).attr("href"); 
    $('html, body').animate({
        scrollTop: $(href).offset().top
    }, 10);
});
if($(".swatches-variant-images-square.product-options-style-radio .option-value-input").length > 0){
  $(".swatches-variant-images-square.product-options-style-radio .option-value-input").each(function(){
    var alt = $.trim($(this).attr("value"));
    var src = $(".product-gallery--media-thumbnail img[alt='"+alt+"']").attr("src"); console.log(alt+"==="+src);
      $(this).parents(".option-value-label").find(".option-value-image .swatch-inner").attr('style',"background-image:url('"+src+"');width:64px;border:0;");
  })
}
$("body").on("click",".swatches-variant-images-square.product-options-style-radio .option-value-input",function(){
var text = $(this).attr("value");
console.log(text);
$(".product-gallery--media-thumbnail").each(function(){
var alt = $(this).find("img").attr("alt"); console.log(alt+"======"+text);
if($.trim(alt) == $.trim(text)){
$(this).trigger("click");
return false;
}
});
});
  $("body").on('click', '.scroller-content-jtpl a', function(e){  
 e.preventDefault();   
  var hrefScroll = $(this).attr("href"); 
    $('html, body').animate({
        scrollTop: $("."+hrefScroll).offset().top -100
    }, 10);
});
   $(document).on("Searchanise.ResultsUpdated", function () {
       $('.snize-product-tag-custom-printed-towels').each(function() {
         var $this2 = $(this);
           var product_url = $(this).find("a").attr("href");
              var curr = $(this).find(".snize-view-link")  
                $.ajax({
                    url:product_url,
                    type:'GET',
                    dataType:'html' 
                })
                .done(function(data) {
                    var src = $(data).find(".grid-format-image-slider li:first-child img").attr("src");
                    $this2.find(".snize-item-image").attr("src",src);
                })
                .fail(function(data) {})
                .always(function(data) {});  
            });
$('.snize-product-tag-featured-search').each(function() {
         var $this2 = $(this);
           var product_url = $(this).find("a").attr("href");
              var curr = $(this).find(".snize-view-link")  
                $.ajax({
                    url:product_url,
                    type:'GET',
                    dataType:'html' 
                })
                .done(function(data) {
                    var src = $(data).find(".grid-format-image-slider li:first-child img").attr("src");
                    $this2.find(".snize-item-image").attr("src",src);
                })
                .fail(function(data) {})
                .always(function(data) {});  
            }); 
   });
/*****************************/
$("body").on('click', '.btn-next-order-sample a', function(e){  
 e.preventDefault(); 
  var name = $('#input-s-1bfeef94-ed3c-4aea-a011-78c3a73692d7').val();
  var lastname = $("#input-s-3c486452-1405-4070-8dd7-9db6796100e4").val();
  var company = $("#input-s-6d7f1cc7-8a55-4021-ba9d-422708d08adc").val();
  var email = $("#input-s-cdb38e87-0d67-4dfa-b749-50a3b71777ed").val();
  var phone = $("#input-s-8658ee33-2ec1-48e9-ad52-1e6be634131e").val();
  var message = $("#form-textarea-s-5c30d1e1-2405-4346-ad20-845812b06496").val();
  $(".first-step-cstm").find().remove();
  if(name=="" || lastname =="" || company == "" || email=="" || phone =="" || message ==""){
    var error = "<span class='error error-msg' style='color:red;'>Please enter mandatory fields!</span>";
    $(".first-step-cstm").append(error);
    return false;
  }else{
   $('.main-form-sct-cstm.last-step-cstm').addClass('active');
    $('.main-form-sct-cstm.first-step-cstm').addClass('older-step');
  }
});
function UpdatePricingBanner(){
/*****************************  Intelligems  as low as on collection start    *****************************/
var campaigns_data = igData.campaigns.getAll();
  console.log(igData);
  console.log(campaigns_data);
  for(var zz=0; zz<campaigns_data.length; zz++){
    var name = campaigns_data[zz].name;
   var camp_desc = campaigns_data[zz].description;
    camp_desc = camp_desc.replace('"','');
    camp_desc = camp_desc.replace("'",'');
    var tiers_length = campaigns_data[zz].discount.tiers.length;
    var discountType = campaigns_data[zz].discount.discountType;
    var ret = parseInt(tiers_length) - 1 ;
    var max_price = campaigns_data[zz].discount.tiers[ret].maximumUnits;
    var minUnit = campaigns_data[zz].discount.tiers[ret].minimumUnits;
    if(discountType == "percentage"){
      if($("li.productgrid--item[data-sku='"+name+"']").length > 0){
      var unitDiscount =  parseFloat($("li.productgrid--item[data-sku='"+name+"']").attr("data-price")) * parseFloat(campaigns_data[zz].discount.tiers[ret].unitDiscount)/100 ;
      }
       if($("li.productgrid--item[data-description='"+camp_desc+"']").length > 0){
         var unitDiscount =  parseFloat($("li.productgrid--item[data-description='"+camp_desc+"']").attr("data-price")) * parseFloat(campaigns_data[zz].discount.tiers[ret].unitDiscount)/100 ;
      }
    }else{
      var unitDiscount = campaigns_data[zz].discount.tiers[ret].unitDiscount;
    
    }
    if($("li.productgrid--item[data-sku='"+name+"']").length > 0){
     var discounted_price = parseFloat($("li.productgrid--item[data-sku='"+name+"']").attr("data-price")) - parseFloat(unitDiscount);
    $("li.productgrid--item[data-sku='"+name+"']").find(".intelligems-as-low-as-price-jtpl span").text("$"+ discounted_price.toFixed(2) + " /each");
    $("li.productgrid--item[data-sku='"+name+"']").find(".intelligems-as-low-as-price-jtpl").css("display","block");
    $("li.productgrid--item[data-sku='"+name+"']").find(".intelligems-as-low-as-price-jtpl").next().css("display","none");
      continue;
    }
     if($("li.productgrid--item[data-description='"+camp_desc+"']").length > 0){
     var discounted_price = parseFloat($("li.productgrid--item[data-description='"+camp_desc+"']").attr("data-price")) - parseFloat(unitDiscount);
    $("li.productgrid--item[data-description='"+camp_desc+"']").find(".intelligems-as-low-as-price-jtpl span").text("$"+ discounted_price.toFixed(2) + " /each");
    $("li.productgrid--item[data-description='"+camp_desc+"']").find(".intelligems-as-low-as-price-jtpl").css("display","block");
    $("li.productgrid--item[data-description='"+camp_desc+"']").find(".intelligems-as-low-as-price-jtpl").next().css("display","none");
       continue;
    }
/***************************** Intelligems pdp banner start   *****************************/
     var name_text = $.trim($("span[data-product-sku]").text()).toUpperCase();
     var name_upr = name.toUpperCase();
     var description_text = $.trim($("h1.product-title").text()).toUpperCase();
     var description_upr = camp_desc.toUpperCase();
if($(".template-product .multi-tier-wrapper").length > 0 && (name_upr == name_text ||  description_upr.replace('"','') == description_text.replace('"','').replace('"',''))){
       var product_html_1 = '<div class="multi-tier-items">Order More</div>';
       var product_html_2 = '<div class="multi-tier-items">Save More!</div>';
       var tiers_data = campaigns_data[zz].discount.tiers;
        for(var xx=0; xx< tiers_data.length ; xx++){
          var max_price_2 = tiers_data[xx].maximumUnits;
          var minUnit_2 = tiers_data[xx].minimumUnits;
           console.log(tiers_data[xx]);
            var max_price_2 = $(".product-main .price--main .money").text();
            console.log("max_price_2"+ max_price_2);
          var main_price_2 = max_price_2.replace("$","");
          var product_type = $(".product-main .product--price .price--main .product-type").text();
          if(product_type.indexOf("each") > -1){
            var pro_type_data = "each";
          }else{
            var pro_type_data = "pack";
          }
         if(discountType == "percentage"){
           var unitDiscount_2 = parseFloat(main_price_2) * tiers_data[xx].unitDiscount/100;
          }else{
          var unitDiscount_2 = tiers_data[xx].unitDiscount;
          }
          var disc_price = parseFloat(main_price_2) - parseFloat(unitDiscount_2);
          if(discountType == "percentage"){
           var persentDiscount_2 = tiers_data[xx].unitDiscount
          }else{
          var persentDiscount_2 = 100 - (disc_price / parseFloat(main_price_2)*100);
          }
          product_html_1+= '<div class="multi-tier-items"><span id="intelligems-quantity-jtpl-'+xx+'" class="intelligems-quantity-jtpl" data-index="'+xx+'" data-qty="'+minUnit_2+'">'+minUnit_2+' </span> + <span> '+pro_type_data+'</span></div>';
          product_html_2+= '<div class="multi-tier-items"><span id="intelligems-discounted-price-jtpl-'+xx+'" class="intelligems-discounted-price-jtpl" data-index="'+xx+'" data-tier-price='+disc_price.toFixed(2)+'>$'+disc_price.toFixed(2)+' </span><span>/ '+pro_type_data+'</span><span class="precentage_offer"><span id="intelligems-precentage-price-jtpl-'+xx+'" class="intelligems-precentage-price-jtpl"> '+Math.round(persentDiscount_2)+'%</span> off</span></div>';
        }
      $(".multi-tier-wrapper .multi-tier-body:first-child .multi-tier-items-jtpl").html(product_html_1);
      $(".multi-tier-wrapper .multi-tier-body:last-child .multi-tier-items-jtpl").html(product_html_2);
      $(".popup-notification.product.multi-tier-breaks").attr("style","display:block !important");
    break;
} 
/*****************************  Intelligems pdp banner start    *****************************/
}
/*****************************  Intelligems pdp banner tagged customer start    *****************************/
var tagged_custm_var_id = $(".tagged-customer-banner-intelligems-jtpl").attr("data-variant-id-tagged-customer");
if ($("body.tagged-cst-jtpl").length) {
  $(".product--container .appstle_sub_widget").hide()
}
else{
  $(".product--container .appstle_sub_widget").show()
}

var tagged_price = igData.price.getPriceByVariantId(tagged_custm_var_id);
 var new_price = "$" + Number(tagged_price).toFixed(2);
var product_type = $('span.product-type').text();
 var  new_product_type = product_type.split('/');
  if($.trim(new_product_type[1]) == $.trim(new_product_type[2])){
    product_typeVal = new_product_type[1];
  }else{
    product_typeVal = new_product_type;
  }
   var original_product_price = $(".custom-product-discount-pricing span").attr("p_price");
    if(original_product_price.indexOf("$")> -1){
        var integer_product_price = parseFloat(original_product_price.split("$")[1]);
    }else{
      var integer_product_price = parseFloat(original_product_price);
    }
 // Extract number after "$"
console.log(original_product_price+"....original_product_price:..... " + integer_product_price+"...tagged_price");
 var integer_product_price_float= parseFloat(integer_product_price);
  var tagged_float =parseFloat(tagged_price);
   console.log("tagged_float ----"+tagged_float);
  var customer_tag =$(".price-container .customer-quantity-box .customer-quantity-icon-title .small-text").attr("customer-tag")
  console.log("customer_tag"+customer_tag)
  var discount_percentage =integer_product_price_float - tagged_float;
    console.log("discount_percentage"+discount_percentage);
  var percentageDiscount = (discount_percentage / integer_product_price_float) * 100;
  var fixeddiscount =Math.floor(percentageDiscount);
  console.log("withoutfloat"+fixeddiscount);
  if($(".price-container .customer-quantity-box").length > 0 && tagged_price != null && $(".customer-tags-ulr").val() != "" && $(".customer-tags-ulr").val() != undefined){
     $(".price-container").css("display", "block");
   $(".price-container .customer-quantity-box .customer-quantity-price .quantity-retail-price").html(original_product_price);
     $(".price-container .customer-quantity-box .customer-quantity-price .quantity-wholesale-price").html("$"+parseFloat(discount_percentage).toFixed(2));
     $(".price-container .customer-quantity-box .quantity-discount-price .quantity-percentage-dsicount").html(fixeddiscount+"%")
  };
if($(".tagged-customer-banner-intelligems-jtpl .tagged-customer-banner-intelligems-price-jtpl").length > 0 && tagged_price != null && $(".customer-tags-ulr").val() != "" && $(".customer-tags-ulr").val() != undefined){
  $(".tagged-customer-banner-intelligems-jtpl").css("display", "block");
  var original_price = $(".custom-product-discount-pricing span").attr("p_price");
   $(".tagged-customer-banner-intelligems-jtpl .tagged-customer-banner-intelligems-price-jtpl").text(tagged_price);
     $(".custom-product-discount-pricing span.money").html(new_price);
  function priceUpdateMoney(){
   $(".custom-product-discount-pricing").html(`<span p_price="${original_price}">${new_price}</span>`);
    setTimeout(function(){
       $(".custom-product-discount-pricing span").addClass("money");
    }, 4000);
  }
 priceUpdateMoney();
  $('body').on('click touchstart mouseenter keyup', function() {
     priceUpdateMoney();
  });
if($(".appstle_one_time_details_wrapper .appstle_subscription_amount_compare_at_price.transcy-money").length > 0 && tagged_price == null || tagged_price == ''){
    $(".appstle_one_time_details_wrapper .appstle_subscription_amount_compare_at_price.transcy-money").remove();
  }           
  $(".tagged-customer-banner-intelligems-jtpl .th-discount-product-type").html(product_typeVal);
  if($(".appstle_subscription_amount_wrapper").length > 0 && $(".tagged-customer-banner-intelligems-jtpl .tagged-customer-banner-intelligems-price-jtpl").length > 0 && tagged_price != null){   
  console.log("heree");
  var qty = parseInt($('#product-quantity-input').val());
    var main_price = tagged_price;
     $(".appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money").html("$"+tagged_price);
      $(".appstle_subscription_amount_wrapper .appstle_subscription_compare_amount.transcy-money").html("$"+tagged_price);
    var calc_main_price = main_price.replace("$","");
      var main_disocunted_price = calc_main_price - (calc_main_price*5/100);
      main_disocunted_price = main_disocunted_price.toFixed(2);
     $(".appstle_subscription_amount_wrapper .appstle_subscription_amount.transcy-money").html("$"+main_disocunted_price);
 $(".appstle_single_option_text .transcy-money").html("$"+main_disocunted_price);
  }
}
/*****************************  Intelligems pdp banner tagged customer end    *****************************/      
/*****************************  Intelligems  as low as on collection end    *****************************/
}
if($("body").hasClass("template-collection") && $("body").hasClass("tagged-cst-jtpl")){}else{
  window.addEventListener('ig:ready', () => {
   UpdatePricingBanner();
   $(document).on('change','.product-options-style-select .no-js-required',function(){
   var var_ID = $(this).find("option:selected").val();
   $(".tagged-customer-banner-intelligems-jtpl").attr("data-variant-id-tagged-customer",var_ID);
   setTimeout(function(){
   UpdatePricingBanner();
   },10)
 });
});
}
if($(".cstm-current-stock").length > 0){
   function updateInventoryQuantity() {
        var current_data_variantQty = $('.prpty-marking-select option:selected').attr('data-variant-quantity');
        if (typeof current_data_variantQty === 'undefined' || current_data_variantQty === null) {
            current_data_variantQty = 0;
        }
        $(".crrnt-jtpl-qty").html(current_data_variantQty);
    }
    let stockElements = document.getElementsByClassName("cstm-current-stock");
    for (let i = 0; i < stockElements.length; i++) {
      stockElements[i].style.display = "block";
    }
    updateInventoryQuantity();
}
$('.friday-announcement-main').removeClass('jtpl_hidden');
  if($('body').hasClass('ter-pro-cleaner-registration')){
    $('body').find('.page-masthead').addClass('hidden')
  }
function round(value, exp) {
  if (typeof exp === 'undefined' || +exp === 0)
    return Math.round(value);
  value = +value;
  exp = +exp;
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
    return NaN;
  value = value.toString().split('e');
  value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
}
$(document).ready(function() {
  printingQuantityValid();
var pagecrrnturl =  window.location.href;
  if (pagecrrnturl.indexOf("pages/new-property-page") > -1){
          var totalCookiesNow =  getCookie('itemsArr')
    if(totalCookiesNow == ''){
      window.location.href = "/";
    }
    var currntProduct = getCookie("currentProduct");
    var  currntProductPrice = getCookie("currentProductPrice"); 
    var currntProductType = getCookie("currentProductType"); 
    var currntPageType = getCookie("currentPageType");
    var currntProductColor =  getCookie("currntProductColor");
    var currntProductQauntity =  getCookie("currntProductQauntity");
    var pintingPricesAddon =  getCookie("pintingPricesAddon");
    var ProductPack =  getCookie("ProductPack");
    var totalPricingAdd = currntProductQauntity * ProductPack;
    var firstTierQuantity = getCookieNew("FirstTierQuantity");
    var secondTierQuantity = getCookieNew("SecondTierQuantity");
    var thirdTierQuantity = getCookieNew("ThirdTierQuantity");
    var firstTierDiscount = getCookieNew("FirstTierDiscount");
    var secondTierDiscount = getCookieNew("SecondTierDiscount");
    var thirdTierDiscount = getCookieNew("ThirdTierDiscount");
   var  CurrProductHandle = getCookieNew("ProductHandle");
    if(pintingPricesAddon == '16x24'){
      $("#custom-image-printing-images-jtpl").addClass("not-sqare-size-jtpl")
    }
    if (currntPageType == 'productPage'){
       $("[data-varinat-color="+currntProductColor+"]").trigger( "click" );
      $(".color-variants li").hide();
    }
    $("[data-printing-title="+pintingPricesAddon+"]").attr( "selected","selected" );
    $(".property-marking-page-title-jtpl .product-title").html(currntProduct);
    $(".product-price-show .inner_price").html(currntProductPrice+currntProductType);
    
      var selectedPrnting = $('.printing-pricing-jtpl').find(":selected").attr("data-printing-id");
     var selectedPrntingPrice = $('.printing-pricing-jtpl').find(":selected").attr("data-printing-price");
     var currntqantity1 = $('.new-custom-qty__wrapper').find("#product-quantity-input2").attr("value");
      var currntqantity = parseInt(currntqantity1);
    var selectedPrntingPrice = parseFloat(selectedPrntingPrice);
    var TotalPrntingPrice = selectedPrntingPrice * totalPricingAdd;
    var packedPricng = ProductPack * selectedPrntingPrice;
       var packedPricng = parseFloat(packedPricng).toFixed(2);
    setTimeout(function(){
       var main_price = $(".all-property-products-details .price-to-be-updated").text();
   console.log(main_price+"===="+packedPricng);
    var total_price_per_pack = parseFloat(main_price) + parseFloat(packedPricng);
      total_price_per_pack =total_price_per_pack.toFixed(2);
      $(".prop-price").append(" + $"+packedPricng+"/per Pack ");
        
      $(".printing-pricing").append(" +Printing Price $"+TotalPrntingPrice);
    $(".product-price-show .inner_price").html("$"+total_price_per_pack);
    $.ajax({
     url:'https://www.microfiberwholesale.com/products/'+CurrProductHandle+'?view=ajax-reviews',
     type:'GET',
     success: function(data){
       $('#ReviewsWidget').html(data);
       }
});
     },300)
    
  }
  setTimeout(function(){
    if($.trim($('.all-property-products-details').html()).length != 0){
      $('.all-property-products-details').addClass('border_visible');
    }
  },100)
  var title_arr = [];
  var new_arry_title = {};
  var items = [];
    $(document).on('click','[add_to_cart_click]',function(e){
    e.preventDefault();
    var ProductHandle = $(this).attr("product-handle")
    $('body').addClass('button-popup-enable');
    $('#customize-property-popup.button-select-popup').addClass('second-button-show');
      if($('.varient_select_current option:selected').length > 0){
        var current_data_image = $('.varient_select_current option:selected').attr('var_image');
      }
      else {
        var current_data_image = $('.prpty-marking-select option:selected').attr('data-variant-img');
      }
      setCookie("image",current_data_image,180);
      var pro_title = $('.product--container').find('.product-title').html().trim();
      var pro_price = $('.product--container').find('.custom-product-discount-pricing .money').text().trim();
      var pro_qty   = $('#product-quantity-input').val();
      var current_price = $(this).attr('price_qty');
      var final_price = (pro_qty*current_price);
      if($('.product--container').find('.option-header').length > 0 ){
        var pro_varient = $('.product--container').find('.option-header').html().trim();
      }
      var pro_Type =$('.product--container').find('.price--main.product-page-style .product-type').text().trim();
      if($('.varient_select_current option:selected').length > 0){
        var varient_idd = $('.varient_select_current option:selected').val().replace(/,/g , '');
      }
      else{
        var varient_idd = $(this).attr('data__id').replace(/,/g , '');
      }
      var pro_image = getCookie("image");
    
      var newArr = '';
      newArr = varient_idd+"~"+pro_title+"~"+final_price+"~"+pro_qty+"~"+pro_image+"~"+pro_varient+"~"+current_price+"*";
       var pro_Type =$('.product--container').find('.price--main.product-page-style .product-type').text().trim();
       var pro_color = $(".product--container").find(".option-swatch-value").text().trim().toLowerCase();
      var data_to_add = $(this).attr("data-addon");
      var data_to_addPack = $(this).attr("data-qantity-pack");
      if($("#intelligems-discounted-price-jtpl-0").length){
      var first_tier_discount = $("#intelligems-discounted-price-jtpl-0").attr("data-tier-price").trim();
      setCookieNew("FirstTierDiscount", first_tier_discount, 30);
      }
       if($("#intelligems-discounted-price-jtpl-1").length){
      var second_tier_discount = $("#intelligems-discounted-price-jtpl-1").attr("data-tier-price").trim();
      setCookieNew("SecondTierDiscount", second_tier_discount, 30);
       }
      if($("#intelligems-discounted-price-jtpl-2").length){
      var third_tier_discount = $("#intelligems-discounted-price-jtpl-2").attr("data-tier-price").trim();
      setCookieNew("ThirdTierDiscount", third_tier_discount, 30);
      }
      if($("#intelligems-quantity-jtpl-0").length){
      var first_tier_quatity = $("#intelligems-quantity-jtpl-0").html().trim();
      setCookieNew("FirstTierQuantity", first_tier_quatity, 30);
      }
      if($("#intelligems-quantity-jtpl-1").length){
      var second_tier_quatity = $("#intelligems-quantity-jtpl-1").html().trim();
      setCookieNew("SecondTierQuantity", second_tier_quatity, 30);
      }
      if($("#intelligems-quantity-jtpl-2").length){
      var third_tier_quatity = $("#intelligems-quantity-jtpl-2").html().trim();
      setCookieNew("ThirdTierQuantity", third_tier_quatity, 30);
      }
      var pro_quantity = $("#product-quantity-input").val()
        items.push(newArr);
      var cookArr = getCookie("itemsArr");
      if(cookArr){
       var cookArrNew = [];
      cookArr = cookArr.split(',');
         setCookie("itemsArr",newArr,180);
      }else{
          setCookie("itemsArr",newArr,180);
      }
     console.log('cookie set value : ' + getCookie("itemsArr"));
      $('.dta_crt_page').attr('product_cart_id',varient_idd);
      $('.dta_crt_page').attr('product_cart_qty',pro_qty);
      $('.customizer-button-outer-jtpl').removeClass('hidden');
      setCookieNew("currentProduct", pro_title, 30);
      setCookieNew("currentProductPrice", pro_price, 30);
      setCookieNew("currentProductType", pro_Type, 30);
      setCookieNew("currentPageType", "productPage", 30);
      setCookieNew("currntProductColor", pro_color, 30);
      setCookieNew("currntProductQauntity", pro_quantity, 30);
      setCookieNew("pintingPricesAddon", data_to_add, 30);
      setCookieNew("ProductPack", data_to_addPack, 30);
      setCookieNew("ProductHandle", ProductHandle, 30);
      if($(".tagged-customer-banner-intelligems-price-jtpl").length){
      var taggedCustomer = $(".tagged-customer-banner-intelligems-price-jtpl").html().trim();
      setCookieNew("taggedCustomer", taggedCustomer, 30);
      }
      var current_data_variant = $('.prpty-marking-select option:selected').attr('data-variant-id');
        $(".dta_crt_page").attr("product_cart_id",current_data_variant)
  });
  function printingQuantityValid() {
         var quantity_customiz = $('#product-quantity-input').val();
    var quantity_customiz = parseInt(quantity_customiz);
    var currnt_color =  $('.prpty-marking-select option:selected').attr('data-check-jtpl');
    var min_qantty = $("#AddToCart").attr("data-quantty-min")
    var min_qantty  = parseInt(min_qantty);
console.log(quantity_customiz+"======"+min_qantty)
    
    if(quantity_customiz >= min_qantty && currnt_color !== 'Black' && !currnt_color.includes(',')){
      $("#AddToCart").attr("add_to_cart_click" ,"true")
    }else{
       $("#AddToCart").removeAttr("add_to_cart_click")
    }
  }
  $('#product-quantity-input').on('keyup', function(e) {    
     printingQuantityValid();
    
});
     var cookArr = getCookie("itemsArr");
 
  if(cookArr){
      var cookArr = getCookie('itemsArr').split('*');
      $.each(cookArr, function (key, value) {
        var currentData = this;
        var cook__data__val = value.split('~');
        var variant_id_2 = cook__data__val[0];
        var pro_title_2 = cook__data__val[1];
        var pro_price_2 = cook__data__val[2];
        var pro_price_2 = parseFloat(pro_price_2).toFixed(2);
        var pro_qty_2 = cook__data__val[3];
        var pro_image_2 = cook__data__val[4];
        var pro_varient_2 = cook__data__val[5];
        var current_single_price = cook__data__val[6];
        var pro_price_2 = parseFloat(pro_price_2) + parseFloat(TotalPrntingPrice);
        var pro_price_2  = parseFloat(pro_price_2).toFixed(2);
        if(pro_varient_2 != 'undefined'){
          pro_varient_2 = pro_varient_2;
        }
        else{
          pro_varient_2 = "";
        }
        var pro_qty_2 = parseInt(pro_qty_2);
          var firstTierQuantity = getCookieNew("FirstTierQuantity");
    var secondTierQuantity = getCookieNew("SecondTierQuantity");
    var thirdTierQuantity = getCookieNew("ThirdTierQuantity");
    var firstTierDiscount = getCookieNew("FirstTierDiscount");
    var secondTierDiscount = getCookieNew("SecondTierDiscount");
    var thirdTierDiscount = getCookieNew("ThirdTierDiscount");
    var taggedCustomerPrice = getCookieNew("taggedCustomer");
        if(firstTierQuantity){
        var firstTierQuantity = parseInt(firstTierQuantity);
        if (pro_qty_2 >= firstTierQuantity ){
          var current_single_discount = firstTierDiscount;
        }
        }
        if(secondTierQuantity){
          var secondTierQuantity = parseInt(secondTierQuantity);
        if (pro_qty_2 >= secondTierQuantity ){
          
          var current_single_discount = secondTierDiscount;
        }
        }
        if(thirdTierQuantity){
        var thirdTierQuantity = parseInt(thirdTierQuantity);
        if (pro_qty_2 >= thirdTierQuantity ){
          var current_single_discount = thirdTierDiscount;
        }
        }
        if(taggedCustomerPrice){
          var current_single_discount = taggedCustomerPrice;
        }
            var new_price = parseFloat(current_single_discount);
            var final_price = parseFloat(pro_qty_2*new_price).toFixed(2);
            var finalPrintingPriceTotal =  parseFloat(pro_qty_2*packedPricng).toFixed(2);
            var FinalSubtotal = parseFloat(finalPrintingPriceTotal)+parseFloat(final_price);
             var  FinalSubtotal = parseFloat(FinalSubtotal).toFixed(2);
        if(cook__data__val != ''){
          $(".all-property-products-details").append("<div class='prop-pro-outer-wp product_selected_true' data_pro_id="+variant_id_2+" data_pro_price="+current_single_discount+" data_final_price="+pro_price_2+">  <div class='prop-image-cell'><img src="+pro_image_2+"/></div>  <div class='prop-title-price-outer'><h2>"+pro_title_2+"</h2> <legend class='option-header prop-varient-select'>"+pro_varient_2+"</legend> <span class='prop-price-2 th_do_item_price money'></span><span class='prop-price th_do_item_price money'>"+"<span class='original-price-jtpl cart-item--sale-price'>$"+current_single_price+"</span>$<span class='price-to-be-updated'>"+current_single_discount+"</span></span> </div>   <div class='js-qty__wrapper new-custom-qty__wrapper'>  <button type='button' class='js-qty__adjust2 product-js-qty__adjust2 js-qty__adjust--minus2 qty_selected select_minus'>-</button> <input type='text' id='product-quantity-input2' class='js-qty__num2 qty-inner-select-val2' value="+pro_qty_2+">  <button type='button' class='js-qty__adjust2 product-js-qty__adjust2 js-qty__adjust--plus2 qty_selected select_plus' id='qty__adjust--plus-id2'>+</button><div class='totalPrinting-marking'><span class='product-marking-total'>Total: <b>$"+FinalSubtotal+"</b></span><span class='printing-pricing'></span></div> </div> <div class='prop-checked-icon image_show'> <img src='https://cdn.shopify.com/s/files/1/0280/4006/9155/files/check_icon_2x-8.png?v=1714363809'/><span class='image_round jtpl_hidden'></span> </div></div>");
        }
                 return false;
      });
  }
  $(document).on('click','.dta_crt_page',function(e){
    e.preventDefault();
    var cart_id = $(this).attr('product_cart_id');
    var cart_qty = $(this).attr('product_cart_qty');
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'JSON',
      data: {id:cart_id, quantity:cart_qty},
      success: function(){
        console.log("success");
    
      },
      error: function(){
        console.log("fail");
      }
    })
  });
      $('.product_selected_true').each(function(){
        var sel_cart_id = $(this).attr('data_pro_id').replace(/,/g , '');
        var sel_cart_qty = $(this).find('.qty-inner-select-val').val();
      })

  $(document).on('click','.prop-checked-icon img',function(){ 
    return false;
    $(this).addClass('jtpl_hidden').siblings('').removeClass('jtpl_hidden');
    $(this).parents('.prop-checked-icon').toggleClass('image_show');
    $(this).parents('.prop-pro-outer-wp').toggleClass('product_selected_true');
    $(this).parents('.prop-pro-outer-wp').remove();
  
    setTimeout(function () {
      var totalCookiesNow =  getCookie('itemsArr')
    if(totalCookiesNow == ''){
      window.location.href = "/";
    }
       },1500);
  });

  $(document).on('click','.image_round',function(){
    $(this).addClass('jtpl_hidden').siblings('').removeClass('jtpl_hidden');
    $(this).parents('.prop-checked-icon').toggleClass('image_show');
    $(this).parents('.prop-pro-outer-wp').toggleClass('product_selected_true');
  });

  var DTA_arry_id = [];
  var DTA_arry_qty = [];
    $(document).on('click','#customize-property-popup .close-icon-cell svg',function(e){
      e.preventDefault();
      $('#customize-property-popup.button-select-popup').removeClass('second-button-show');
      $('body').removeClass('button-popup-enable');
    });

    $(document).on('click','.prop-pro-outer-wp .qty_selected',function(e){
      e.preventDefault();
    var firstTierQuantity = getCookieNew("FirstTierQuantity");
    var secondTierQuantity = getCookieNew("SecondTierQuantity");
    var thirdTierQuantity = getCookieNew("ThirdTierQuantity");
    var firstTierDiscount = getCookieNew("FirstTierDiscount");
    var secondTierDiscount = getCookieNew("SecondTierDiscount");
    var thirdTierDiscount = getCookieNew("ThirdTierDiscount");
    var taggedCustomerPrice = getCookieNew("taggedCustomer");
        var qty_qty = parseFloat($(this).siblings('.qty-inner-select-val2').val());
          if($(this).hasClass('select_plus')){
            var new_qty_qty = parseFloat((qty_qty+1));
        if(firstTierQuantity){
        var firstTierQuantity = parseInt(firstTierQuantity);
        if (new_qty_qty >= firstTierQuantity ){
          var current_single_discount = firstTierDiscount;
        }
        }
        if(secondTierQuantity){
          var secondTierQuantity = parseInt(secondTierQuantity);
        if (new_qty_qty >= secondTierQuantity ){
          
          var current_single_discount = secondTierDiscount;
        }
        }
        if(thirdTierQuantity){
        var thirdTierQuantity = parseInt(thirdTierQuantity);
        if (new_qty_qty >= thirdTierQuantity ){
          var current_single_discount = thirdTierDiscount;
        }
        }
        if(taggedCustomerPrice){
          var current_single_discount = taggedCustomerPrice;
        }
            var new_price = parseFloat(current_single_discount);
            var final_price = parseFloat(new_qty_qty*new_price).toFixed(2);
            $(this).siblings('.qty-inner-select-val2').val(new_qty_qty);
            var finalPrintingPriceTotal =  parseFloat(new_qty_qty*packedPricng).toFixed(2);
            var FinalSubtotal = parseFloat(finalPrintingPriceTotal)+parseFloat(final_price);
             var  FinalSubtotal = parseFloat(FinalSubtotal).toFixed(2);
            $(".price-to-be-updated").html(new_price);
            $(this).parents('.prop-pro-outer-wp').find('.product-marking-total').html("Total: <b>$"+FinalSubtotal+"</b>");
            $(this).parents('.prop-pro-outer-wp').find('.printing-pricing').html("+Printing Price $"+finalPrintingPriceTotal); 
          }
          else{
              var new_qty_qty = parseFloat((qty_qty-1));
        if(qty_qty > 1){
        if(firstTierQuantity){
        var firstTierQuantity = parseInt(firstTierQuantity);
        if (new_qty_qty >= firstTierQuantity ){
          var current_single_discount = firstTierDiscount;
        }
        }
        if(secondTierQuantity){
          var secondTierQuantity = parseInt(secondTierQuantity);
        if (new_qty_qty >= secondTierQuantity ){
          
          var current_single_discount = secondTierDiscount;
        }
        }
        if(thirdTierQuantity){
        var thirdTierQuantity = parseInt(thirdTierQuantity);
        if (new_qty_qty >= thirdTierQuantity ){
          var current_single_discount = thirdTierDiscount;
        }
        }
        if(taggedCustomerPrice){
          var current_single_discount = taggedCustomerPrice;
        }
              var new_price = parseFloat(current_single_discount);
              var final_price = parseFloat(new_qty_qty*new_price).toFixed(2);
              var finalPrintingPriceTotal =  parseFloat(new_qty_qty*packedPricng).toFixed(2);
              var FinalSubtotal = parseFloat(finalPrintingPriceTotal)+parseFloat(final_price);
              var  FinalSubtotal = parseFloat(FinalSubtotal).toFixed(2);
              $(".price-to-be-updated").html(new_price);
              $(this).siblings('.qty-inner-select-val2').val(new_qty_qty);
            $(this).parents('.prop-pro-outer-wp').find('.product-marking-total').html("Total: <b>$"+FinalSubtotal+"</b>");
            $(this).parents('.prop-pro-outer-wp').find('.printing-pricing').html("+Printing Price $"+finalPrintingPriceTotal);
            console.log(new_qty_qty);
              
            }
          }
    });
  var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  $("#register_email").keyup(function() {
    var email = $(this).val();
    if (regex.test(email)) {
      $(this).parents('.email-field-form').addClass('valid-email-jtpl');
    } 
    else {
      $(this).parents('.email-field-form').removeClass('valid-email-jtpl');
      
    }
  });
  var discount_percent_jt = parseInt($('.new-upsell-discount').attr('discount_percent_jt'));
/**********************  Property marking js start  ***********************/  
 $("body").on('click', '.cart-item--remove-button', function(event){  
     event.preventDefault();    
   console.log("remove_bundle");
     var item_id_main = $(this).parents('li.cart-item.th_do_cart_line').attr('data-cartitem-id');
    var item_id_adon = $(this).parents('.cartitems--list').find(`li[data-line-item=${item_id_main}]`).attr('data-cartitem-id');      
         $.ajax({
           method : "post",
           url:'/cart/change.js',
           dataType:'json',
           async : false,
           data:{
             'quantity':0,
             'id':item_id_adon
           },
           success:function(rr){
             console.log(rr);
                $.ajax({
                   method : "post",
                 url:'/cart/change.js',
                 async : false,
                   dataType:'json',
                 data:{
                   'quantity':0,
                   'id':item_id_main
                 },                
                 success:function(){
                   if($("body").hasClass("template-cart")){
                          window.location.reload();
                      }else{
                        updateCartDrwaer();
                      }
                 }
               });
           }
         });
        $.ajax({
                 url:'/cart/change.js',
                 async : false,
                 dataType:'json',
                 data:{
                   'quantity':0,
                   'id':item_id_main
                 },                
                 success:function(){
                   if($("body").hasClass("template-cart")){
                          window.location.reload();
                      }else{
                        updateCartDrwaer();
                      }
                 }
               });
  return false;
   });
/**********************  Property marking js end  ***********************/                                                    
/*** grid-template start ***/
  $('.fancybox-popup-product-images-right').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: false,
    verticalSwiping: false,
    variableWidth: true,
    slide: '.fancybox-popup-product-images-inner',
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }
      },
      {
        breakpoint: 461,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

$('.fancybox-popup-product-images-right').on('afterChange', function(event, slick, currentSlide, nextSlide){
   var id = $(".fancybox-popup-product-images-right .fancybox-popup-product-images-inner[data-slick-index='"+currentSlide+"']").attr("id");
    $(".fancybox-popup-product-images .fancybox-popup-product-images-inner").removeClass('active');
     $(".fancybox-popup-product-images .fancybox-popup-product-images-inner[id='"+id+"']").addClass("active");
});
  
  $('.grid-format-image-slider-wrapper').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 900,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    slide: '.grid-format-image-slider-items',
    responsive: [
    {
      breakpoint: 1024,
      settings: {
      dots: false,
      arrows: false,
      infinite: false,
      speed: 900,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false
      }
    },
      {
      breakpoint: 768,
      settings: {
      dots: false,
      arrows: true,
      infinite: false,
      speed: 900,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false
      }
    }
  ]
  });
$(window).resize(function(){
  $('.grid-image-product-template .product-gallery.mobile_view img').css('height', '100%');
});
  var colorValue = $(".swatches-variant-images-square.product-options-style-select .cstm-option-values .option-value.option-selected").find('.option-value-input').attr('value');
   var go_no = $('.grid-format-image-slider-wrapper .grid-format-image-slider-items[data-variant-color="'+colorValue+'"]').attr('data-slick-index');
    $('.grid-format-image-slider-wrapper').slick('slickGoTo', go_no);
 
$("body").on('change',".swatches-variant-images-square.product-options-style-select .cstm-option-values .option-value", function(event){
    var $this = $(this);
   var colorValue = $(this).find('.option-value-input').attr('value');
    console.log(colorValue)
    var go_no = $('.grid-format-image-slider-wrapper .grid-format-image-slider-items[data-variant-color="'+colorValue+'"]').attr('data-slick-index');
    $('.grid-format-image-slider-wrapper').slick('slickGoTo', go_no);
  var PropAttr = $("button#AddToCart").attr('property-marking-on');
  console.log(PropAttr);
     var quantity_customiz = $('#product-quantity-input').val();
    var quantity_customiz = parseInt(quantity_customiz);
    var min_qantty = $("#AddToCart").attr("data-quantty-min")
    var min_qantty  = parseInt(min_qantty);
  if (typeof PropAttr !== 'undefined' && PropAttr !== false) {
  if(colorValue=='Black' || colorValue.includes(',') || quantity_customiz <= min_qantty ){
    $("button#AddToCart").removeAttr("add_to_cart_click");
  }
  else{
    $("button#AddToCart").attr("add_to_cart_click","yes");
  }
    }
}); 
function popup_image_delay(){
  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner").css('opacity', '0');
   $(".fancybox-popup-product-images-right").css('background', '#f0f5f6');
}
function popup_delay(){
  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner").css('opacity', '1');
}
$(document).on('click', '.grid-format-image-container img', function(e){
    e.preventDefault();
    popup_image_delay();
   $('.fancybox-popup').css('display', 'block');
    $("body").addClass("custom-newsletter-popup");
    $('.site-header-wrapper.site-header--sticky').css('position', 'fixed');
    let img_src = $(this).attr("data-zoom");
    let index2 =  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner[data-src='"+img_src+"']").attr("data-slick-index");
    $('.fancybox-popup-product-images-right').slick('slickGoTo',index2);
    setTimeout(popup_delay, 500);
}); 
$(document).on('click', '.grid-format-video', function(e){
    e.preventDefault();
    popup_image_delay();
   $('.fancybox-popup').css('display', 'block');
    $("body").addClass("custom-newsletter-popup");
    $('.site-header-wrapper.site-header--sticky').css('position', 'fixed');
    let video_src = $(this).find('video').attr("poster");
    let index3 =  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner video[poster='"+video_src+"']").parent().attr("data-slick-index");
    $('.fancybox-popup-product-images-right').slick('slickGoTo',index3);
    setTimeout(popup_delay, 500);
});

$("body").on("click",".fancybox-popup-product-images .fancybox-popup-product-images-inner" ,function(){
     popup_image_delay();
     $(".fancybox-popup-product-images .fancybox-popup-product-images-inner").removeClass("active");
     $(this).addClass("active");
     let id = $(this).attr("id");
     let index =  $(".fancybox-popup-product-images-right").find(".fancybox-popup-product-images-inner[id='"+id+"']").attr("data-slick-index");
     $('.fancybox-popup-product-images-right').slick('slickGoTo',index);
     setTimeout(popup_delay, 600);
 });

$(document).on("click", ".popup__close", function () { 
      $(".fancybox-popup").css("display", "none");
          $("body").removeClass("custom-newsletter-popup");
      });
$('body').on('click', '.fancybox-popup-product-images-wrapper', function(e) {
  if (e.target !== this)
    return;
  $(".fancybox-popup").css("display", "none");
  $("body").removeClass("custom-newsletter-popup");
});
/*** grid-template end ***/
/* Cart Upsell 25% manually with script start */
$(".main-content-div").each(function(item){
let get_price = $(this).find($('.upsell-product-prices .pro-price')).text();
    let split_price = get_price.replace('$', '');
  
    let persent_data = discount_percent_jt / 100 * parseFloat(split_price);
    let final_price = parseFloat(split_price) - parseFloat(persent_data);
    $(this).find($(".discounted-pro-price")).text("$" + round(final_price,2));
  
}); 
/* Cart Upsell 25% manually with script end */
/** up-sell cart page start **/
  $(".cstm-data").click(function(){
    var editid = $(this).attr("data-vId");
    var varimg = $(this).attr("data-src")
        $(this).parents(".main-content-div").find(".change-img").addClass("active-img");
    $(this).parents(".main-content-div").find(".change-img").attr("src", varimg);
    $('.cstm-data').removeClass("active-cstm");
    $(this).addClass("active-cstm");
     $(this).parents(".adding-prdct").find(".variantsel").val(editid);
  });
  $('.free-product-varient').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
  });
   $('.upsell_items_main').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
            {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
 $(document).on("click", ".header_popup_cart", function(e){
   $(".limoniapps-notification.closeable").css("display", "none");

});
  $(document).on("click", ".limoniapps-notification-buttons", function(){
    $(this).parents().find(".limoniapps-notification").css("display","none");
});
  
  $('.contributors-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 861,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.gallery-navigation--scroller').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    slide: '.product-gallery--slide',
    responsive: [
      {
        breakpoint: 720,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        }
      },
      {
        breakpoint: 461,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 401,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

    $('.grid-image-product-template .gallery-navigation--scroller').slick('unslick');
  setTimeout(function(){
    $('.productitem--swatches-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slide: 'label',
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      centerMode: false,
      centerPadding: '25px',
      responsive: [
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    });
  },1000);
  $('.testimonials-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  if( $('.banner_wrapper .slide_box').length >0){
     var bannerslides= parseInt($('.banner_wrapper .slide_box').attr('slidetoshow'));
  }
    $('.slide_box').slick({
    dots: false,
    arrows: true,
    infinite:false,
    speed: 500,
    slidesToShow:bannerslides,
    slidesToScroll: 1,
    slidesToShow: 6.2,
    responsive: [
      {
        breakpoint: 1361,
        settings: {
          slidesToShow: 5.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1051,
        settings: {
          slidesToShow: 4.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 772,
        settings: { 
          slidesToShow: 3.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1
        }
      }
    ]
  });
 function initSlickSlider() {
  // Check if the screen width is less than 1024px
  if ($(window).width() < 1024 || $(".header-link").length > 7){
    $(".nav-links-top .header-link").attr("role", "option");
    // Initialize the Slick slider if it's not already initialized
    if (!$('.nav-links-top').hasClass('slick-initialized')) {
      $('.nav-links-top').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 100,
    cssEase: 'linear',
    slidesToShow: 7,
    slidesToScroll: 1,
    swipe: false,
    variableWidth: true,
    infinite: true,
    arrows: false,
    buttons: false,
    responsive: [
      {
        breakpoint: 1251,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1
        }
      },
    ]
      });
    }
  } else {
    // Unslick if the screen width is greater than or equal to 1024px
    if ($('.nav-links-top').hasClass('slick-initialized')) {
      $('.nav-links-top').slick('unslick');
    }
  }
}
  initSlickSlider();
  $(window).resize(function() {
    initSlickSlider();
  });
  $("button.dropdown-toggle").click(function() {
    $(".dropdown-options").hide();
    $(this).parent('.custom-drop-down').find('.dropdown-options').toggle();
  });
  $(".dropdown-options ul li a").click(function() {
    var text = $(this).html();
    $(this).parents('.custom-drop-down').find("button.dropdown-toggle span").html(text);
    $(".dropdown-options").hide();
  }); 
  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (! $clicked.parents().hasClass("custom-drop-down"))
      $(".dropdown-options").hide();
  });
  $(".dropdown-options ul li").each(function(){
    if ($(this).hasClass('active')){      
      var text = $(this).find('a').html();
      $(this).parents('.custom-drop-down').find("button.dropdown-toggle span").html(text);
    }
  });
  if($("body").hasClass("template-blog")){
  $('.popup-youtube').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    iframe: {
      markup: '<div class="mfp-iframe-scaler">'+
      '<div class="mfp-close"></div>'+
      '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
      '</div>', 
      patterns: {
        youtube: {
          index: 'youtube.com/', 

          id: 'v=', 

          src: '//www.youtube.com/embed/%id%?autoplay=1' 
        },
        vimeo: {
          index: 'vimeo.com/',
          id: '/',
          src: '//player.vimeo.com/video/%id%?autoplay=1'
        },
        gmaps: {
          index: '//maps.google.',
          src: '%id%&output=embed'
        }
      },
      srcAction: 'iframe_src', 
    }
  });
  }
  /* Product Qty Adjust Start */
  var $result=$('#product-quantity-input');
  var number= Number($('#product-quantity-input').val());
  var minQty = Number($('#product-quantity-input').attr('min'));
  var isDown=0;
  var delay=150;
  var nextTime=0;
  $(document).on('change','#product-quantity-input',function(e){
    number = Number($(this).val());
    qtyAppstle();
  });

  $(document).on('click change','.appstle_subscription_wrapper_option input, .appstle-radio-wrapper input',function(e){
     qtyAppstle();
    setTimeout(function(){
      qtyAppstle();
    },2000);
  });
  function qtyAppstle(){
     if($(".customer-tags-ulr").length == 0 && $(".appstle_subscription_amount_wrapper").length > 0){
       var qty = parseInt($('#product-quantity-input').val());
       if($(".custom-product-discount-pricing").length > 0){
           var main_price = $(".custom-product-discount-pricing span").attr("p_price");
         console.log("main_priceif",main_price);
       }else{
           var main_price = $(".custom-product-discount-pricing-1 span").attr("p_price");   
           console.log("main_priceelse",main_price);
       }
    $(".appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money").html(main_price);
      $(".appstle_subscription_amount_wrapper .appstle_subscription_compare_amount.transcy-money").html(main_price);
       if(main_price.indexOf("$")>-1){
          var calc_main_price = main_price.replace("$","");
       }else{
         var calc_main_price = main_price;
       }
      var main_disocunted_price = calc_main_price - (calc_main_price*5/100);
     main_disocunted_price = main_disocunted_price.toFixed(2);
     $(".appstle_subscription_amount_wrapper .appstle_subscription_amount.transcy-money").html("$"+main_disocunted_price);
  $(".intelligems-quantity-jtpl").each(function(){
    var min_qty = parseInt($(this).attr("data-qty"));
     var data_index = $(this).attr("data-index");
    var price = $("#intelligems-discounted-price-jtpl-"+data_index).html();
    var calc_price = $("#intelligems-discounted-price-jtpl-"+data_index).attr("data-tier-price");
    //console.log(qty+"======"+min_qty);
    if(qty >= min_qty){
      $(".appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money").html(price);
      $(".appstle_subscription_amount_wrapper .appstle_subscription_compare_amount.transcy-money").html(price);
      var disocunted_price = calc_price - (calc_price*5/100);
      disocunted_price = disocunted_price.toFixed(2);
     //  console.log(calc_price+"======"+disocunted_price);
      $(".appstle_subscription_amount_wrapper .appstle_subscription_amount.transcy-money").html("$"+disocunted_price);
     $(".appstle_single_option_text .transcy-money").html("$"+disocunted_price);
      $(".sellingplan .transcy-money").html("$"+disocunted_price);
    }
  });
     }else if($(".appstle_subscription_amount_wrapper").length > 0){
      var tagged_price = $(".tagged-customer-banner-intelligems-jtpl .tagged-customer-banner-intelligems-price-jtpl").text();
  var qty = parseInt($('#product-quantity-input').val());
    var main_price = tagged_price;
       if(main_price != null && main_price != undefined && main_price != ""){
     $(".appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money").html("$"+tagged_price);
      $(".appstle_subscription_amount_wrapper .appstle_subscription_compare_amount.transcy-money").html("$"+tagged_price);
    var calc_main_price = main_price.replace("$","");
 //   console.log(calc_main_price);
      var main_disocunted_price = calc_main_price - (calc_main_price*5/100);
  // console.log(main_disocunted_price);
     main_disocunted_price = main_disocunted_price.toFixed(2);
     $(".appstle_subscription_amount_wrapper .appstle_subscription_amount.transcy-money").html("$"+main_disocunted_price);
      $(".appstle_single_option_text .transcy-money").html("$"+main_disocunted_price);
     }
       if($(".appstle_one_time_details_wrapper .appstle_subscription_amount_compare_at_price.transcy-money").length > 0 && tagged_price == ""){
     console.log("heree....");
    $(".appstle_one_time_details_wrapper .appstle_subscription_amount_compare_at_price.transcy-money").remove();
  }
     }
  }
  requestAnimationFrame(watcher);
  $('button.product-js-qty__adjust').on({ 'mousedown' : function(e){handleMouseDown(e);} });
  $('button.product-js-qty__adjust').on({ 'mouseup' : function(e){handleMouseUp(e);} });
  $('button.product-js-qty__adjust').on({ 'mouseout' : function(e){handleMouseUp(e);} });
  $('button.product-js-qty__adjust').on({ 'touchstart' : function(e){handleMouseDown(e);} });
  $('button.product-js-qty__adjust').on({ 'touchend' : function(e){handleMouseUp(e);} });
  function handleMouseDown(e){
    // tell the browser we're handling this event
    e.preventDefault();
    e.stopPropagation();

    // Put your mousedown stuff here
    isDown=(e.target.id=='qty__adjust--plus-id')?1:-1;
    qtyAppstle();
  }

  function handleMouseUp(e){
    // tell the browser we're handling this event
    e.preventDefault();
    e.stopPropagation();

    // Put your mouseup stuff here
    isDown=0;
    qtyAppstle();
  }

  function watcher(time){
    requestAnimationFrame(watcher);
    if(time<nextTime){return;}
    nextTime=time+delay;
    if(isDown!==0){
      if(isDown === -1){
        if(number > minQty){
          number+=isDown;
        }else{
          if($('.qty-error-msg-cls').length == 0){
            $('<p class="qty-error-msg-cls">You need to add minimum '+minQty+' qty</p>').insertBefore('.product-form--atc');
          }
        }
      }else{
        number+=isDown;
      }
      $result.val(number);
    }
  }
  $(document).on('click','.js-qty__adjust',function(e){ 
    e.preventDefault();
    var qtyInput = $(this).parents('.js-qty__wrapper').find('.js-qty__num');
    var QtyWraper = $(this).parents('.form-fields--qty').find('.js-qty__wrapper');
    let key=$(this).parents(".cart-item").data("key")
    console.log("changing key--->",key)
    var minValue = qtyInput.attr('min');
    var value = Number(qtyInput.val()), newValue;
    if($(this).hasClass('js-qty__adjust--minus')){
      var newValue = value - 1;
       //alert(newValue);
      if(newValue < minValue){
        if($(this).parents('.form-fields--qty').hasClass('product-form--atc-qty')){
          var newValue = value;
        }else{
          var newValue = minValue;
           if($(this).parents('.form-fields--qty').find('.qty-error-msg-cls').length == 0){
          $('<p class="qty-error-msg-cls">You need to buy minimum '+minValue+' qty</p>').insertBefore(QtyWraper);
        }
        //  alert("Minimum 100 required")
        }
      }
    }
    if($(this).hasClass('js-qty__adjust--plus')){
      var newValue = value + 1;
      if(newValue >= minValue){
        $('.qty-error-msg-cls').remove();
      }
    }
    $(qtyInput).val(newValue);
    $(`.cart .cart-item[data-addon='${key}']`).find(".js-qty__num").val(newValue)
    if($(this).hasClass('cart-qty__adjust')){
      //location.reload();
      $('.cart-update-cls').trigger('click');
    }
      printingQuantityValid();
    return false;
  });
  /* Product Qty Adjust End */
  if($("#shopify-section-static-product-reviews").length > 0){
    $(".product-ratings-scroll").click(function() {
      var afterReviewSectionTop = Number($("#shopify-section-static-product-reviews").offset().top);
      $('html, body').delay(-1000).animate({
        scrollTop: afterReviewSectionTop
      }, 500);
    });
  }
});
function Slickcall(){
  $('.productitem--swatches-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      slide: 'label',
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      centerMode: false,
      centerPadding: '25px',
      responsive: [
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    });
}
$(document).on('click','.utils-viewtoggle-button',function(){
  var viewType = $(this).data('collection-view');
  if(viewType == 'list-view'){
    $('.productitem--swatches-slider').slick('unslick');
  }else{
    Slickcall();
  }
});
$(document).on('change','.js-qty__num',function(){
  var CurrentValue = Number($(this).val());
  var minValue = Number($(this).attr('min'));
  var newValue = minValue;
  var QtyWraper = $(this).parents('.form-fields--qty').find('.js-qty__wrapper');
  if(CurrentValue < minValue){
    if($(this).parents('.form-fields--qty').hasClass('product-form--atc-qty')){
      newValue = minValue;
      if($('.qty-error-msg-cls').length == 0){
        $('<p class="qty-error-msg-cls">You need to add minimum '+minValue+' qty</p>').insertBefore('.product-form--atc');
      }
    }else{
      /*newValue = 0;*/
      if(CurrentValue == 0){
        newValue = 0;
        $(this).parents('.form-fields--qty').find('.qty-error-msg-cls').remove();
      }else{
        newValue = minValue;
        if($(this).parents('.form-fields--qty').find('.qty-error-msg-cls').length == 0){
          $('<p class="qty-error-msg-cls">You need to buy minimum '+minValue+' qty</p>').insertBefore(QtyWraper);
        }
      }
    }
  }else{
    newValue = CurrentValue;
    $('.qty-error-msg-cls').remove();
  }
  $(this).val(newValue);
});
/**********************  Quick links QR page start  ***********************/  

for(let i = 1; i <= 4; i++){
let btn = document.querySelector('.quick_links_'+i);
let el = document.querySelector('.show_quick_links_'+i);
if(el){
btn.addEventListener('click', function () {
    el.scrollIntoView(true);
    $('html, body').animate({
        scrollTop: $(el).offset().top - 150
    }, 'linear');
});
}
}
/**********************  Quick links QR page end  ***********************/  
/****************************** remove localstorage start  ******************/
function removeLocalStorageItems(keys) {
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    setTimeout(function () {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
       // console.log(`Removed '${key}' from localStorage.`);
      } else {
        //console.log(`No item with key '${key}' found in localStorage.`);
      }
    }, 5000 * (i + 1)); 
  }
}
removeLocalStorageItems(['_li_duid', 'la-dn-2070610860549049-promotionevent-queue', 'la-dn-2070610860549049-discounted-cart', 'la-dn-2070610860549049-cached-cart-v8','la-dn-2070610860549049-limoniapps.deviceid.v2', 'la-dn-2070610860549049-version']);
/****************************** removelocal storage end  ********************/
/****************************** remove sessionstorage start  ********************/
function removeSessionStorageItem(key) {
  if (sessionStorage.getItem(key)) {
    sessionStorage.removeItem(key);
  } else {
  }
}
var session_vlaues = ['la-dn-offer-data-OBZRA','la-dn-offer-data-IEDYE','la-dn-offer-accepted-SCZ6S',
'la-dn-offer-data-U05OM',
'la-dn-offerevent-sent-KHXT1--0',
'la-dn-offer-accepted-ICCTB',
'la-dn-offer-data-VPW48',
'la-dn-offer-accepted-S0K5I',
'la-dn-offer-accepted-G1WGE',
'la-dn-offerevent-sent-0DSOB--1',
'la-dn-offer-accepted-8WLVB',
'la-dn-offerevent-sent-DOGVI--1',
'la-dn-offerevent-sent-O020Z--0',
'la-dn-offerevent-sent-78L56--0',
'la-dn-offer-data-FXADF',
'la-dn-offerevent-sent-UVLC7--0',
'la-dn-offer-accepted-8FDMM',
'la-dn-offer-data-5J0KH',
'la-dn-offerevent-sent-X7Q6O--1',
'la-dn-offerevent-sent-Z6552--0',
'la-dn-offerevent-sent-7IHG9--1',
'la-dn-offerevent-sent-KOLM8--1',
'la-dn-offerevent-sent-RTCHL--1',
'la-dn-offerevent-sent-CY0LU--1',
'la-dn-offer-data-CK6G3',
'la-dn-offerevent-sent-SLG04--1',
'la-dn-offerevent-sent-DJ7ZK--0',
'la-dn-offer-accepted-L7BDX',
'la-dn-offer-data-AOY8Z',
'la-dn-offer-accepted-TZLTO',
'la-dn-offerevent-sent-LKX4M--0',
'la-dn-offerevent-sent-WNZTR--0',
'la-dn-offerevent-sent-WZA27--1',
'la-dn-offer-data-QSH0M',
'la-dn-offer-accepted-FXADF',
'la-dn-offerevent-sent-4ZFOQ--0',
'la-dn-offer-data-35AEB',
'la-dn-offer-accepted-ZOK74',
'la-dn-offer-accepted-D8R1V',
'la-dn-offer-accepted-IEDYE',
'la-dn-offer-accepted-Z4677',
'la-dn-offer-data-FVZUS',
'la-dn-offer-data-S1JON',
'la-dn-offer-data-9VU9U',
'la-dn-offer-data-2GYQ5',
'la-dn-offerevent-sent-06492--1',
'la-dn-offerevent-sent-FONWE--0',
'la-dn-offer-accepted-YMSPO',
'la-dn-offerevent-sent-T7NV8--0',
'la-dn-offer-data-Q2IK1',
'la-dn-offerevent-sent-IMB1F--0',
'la-dn-offer-accepted-AOY8Z',
'la-dn-offerevent-sent-TFDGI--1',
'la-dn-offerevent-sent-RTCHL--0',
'la-dn-offer-data-C0LWS',
'la-dn-offerevent-sent-XWMWH--1',
'la-dn-offerevent-sent-KPIYL--1',
'la-dn-offerevent-sent-91H1U--0',
'la-dn-offerevent-sent-D2DLH--0',
'la-dn-offer-data-DOTYV',
'la-dn-offer-data-AUQR7',
'la-dn-offerevent-sent-IFHJI--0',
'la-dn-offer-accepted-840NC',
'la-dn-offer-accepted-Y8DJC',
'la-dn-offer-accepted-S1JON',
'la-dn-offerevent-sent-7ZBXR--0',
'la-dn-offerevent-sent-DBCJ5--0',
'la-dn-cart-adjustment-quantities',
'la-dn-offerevent-sent-1ZLY1--0',
'la-dn-offer-accepted-HBCQ6',
'la-dn-offer-data-YXEN1',
'la-dn-offerevent-sent-45VT--0',
'la-dn-offerevent-sent-JH60B--0',
'la-dn-offerevent-sent-SW95A--0',
'la-dn-offer-data-7WFQ6',
'la-dn-offer-data-I1YMA',
'la-dn-offerevent-sent-PWA4L--0',
'la-dn-offer-data-D35PV',
'la-dn-offer-data-TZLTO',
'la-dn-offerevent-sent-2Q5HQ--1',
'la-dn-offerevent-sent-7WLV5--0',
'la-dn-offer-accepted-XNK9A',
'la-dn-offerevent-sent-LSAFV--0',
'la-dn-offerevent-sent-POMII--0',
'la-dn-offerevent-sent-XULEL--0',
'la-dn-offer-accepted-5J0KH',
'la-dn-offer-accepted-V9ZU2',
'la-dn-offer-data-POO3H',
'la-dn-offer-accepted-EFDXS',
'la-dn-offer-data-TDY69',
'la-dn-offerevent-sent-R46BC--1',
'la-dn-offerevent-sent-42JY7--0',
'la-dn-offerevent-sent-7Y6MD--1',
'la-dn-offerevent-sent-SBH41--0',
'la-dn-offer-accepted-TDY69',
'la-dn-offer-data-E61Y3',
'la-dn-offerevent-sent-LFRTY--0',
'la-dn-offer-accepted-T18I3',
'la-dn-offerevent-sent-6DSJ--0',
'la-dn-offer-data-6453H',
'la-dn-offer-data-ISH7S',
'la-dn-offerevent-sent-KRVUM--0',
'la-dn-offer-data-ZEYRB',
'la-dn-offer-accepted-JF9D4',
'la-dn-offer-data-C20GR',
'la-dn-offer-data-FFFNR',
'la-dn-offerevent-sent-Y8651--1',
'la-dn-offerevent-sent-RTN8U--0',
'la-dn-offer-data-I4D2H',
'la-dn-offerevent-sent-IFHJI--1',
'la-dn-offerevent-sent-EI2I8--1',
'la-dn-offerevent-sent-UTOMM--0',
'la-dn-offerevent-sent-7PHJN--1',
'la-dn-offerevent-sent-DBCJ5--1',
'la-dn-offerevent-sent-XWMWH--0',
'la-dn-offer-accepted-B957Y',
'la-dn-offer-accepted-5CNZ6',
'la-dn-offer-data-9BGQV',
'la-dn-offerevent-sent-OYUDP--0',
'la-dn-offerevent-sent-DA0TJ--0',
'la-dn-offerevent-sent-QTCW8--1',
'la-dn-offerevent-sent-TDSQA--0',
'la-dn-offer-accepted-ZMQ0R',
'la-dn-offer-data-LB2DC',
'la-dn-offer-data-AAT5Q',
'la-dn-offerevent-sent-LTGGH--1',
'la-dn-offerevent-sent-RTN8U--1',
'la-dn-offerevent-sent-01YM6--0',
'la-dn-offerevent-sent-32454--0',
'la-dn-offer-accepted-FVZUS',
'la-dn-offer-accepted-OCRM4',
'la-dn-offerevent-sent-T464C--1',
'la-dn-offerevent-sent-BYMUK--1',
'la-dn-offerevent-sent-TDSQA--1',
'la-dn-offerevent-sent-RMZ84--1',
'la-dn-offerevent-sent-CX8RI--1',
'la-dn-offer-accepted-YDAFW',
'la-dn-offerevent-sent-R8XYV--0',
'la-dn-offer-accepted-CK6G3',
'la-dn-offerevent-sent-LTGGH--0',
'la-dn-offerevent-sent-JR1TQ--0',
'la-dn-offerevent-sent-LH2ZU--1',
'la-dn-offerevent-sent-TLOCC--1',
'la-dn-offerevent-sent-13O2A--0',
'la-dn-offer-accepted-AUQR7',
'la-dn-offer-accepted-LOJZ9',
'la-dn-offer-data-3PITM',
'la-dn-offer-accepted-8UEGG',
'la-dn-offerevent-sent-6B9FC--1',
'la-dn-offer-accepted-NK2UH',
'la-dn-offer-data-HW0FW',
'la-dn-offerevent-sent-XJNZE--1',
'la-dn-offer-accepted-5JK3G',
'la-dn-offer-data-O7LI9',
'la-dn-offerevent-sent-ZJ1Q7--1',
'la-dn-offer-data-840NC',
'la-dn-offerevent-sent-LSAFV--1',
'la-dn-offer-data-29L07',
'la-dn-offer-data-5JK3G',
'la-dn-offer-data-HCJF8',
'la-dn-offer-accepted-OBZRA',
'la-dn-offer-accepted-PHUYY',
'la-dn-offerevent-sent-6NJ2N--0',
'la-dn-offer-accepted-ND98M',
'la-dn-offer-data-N9WN5',
'la-dn-offerevent-sent-VT3S9--1',
'la-dn-session-id',
'gorgias.renderedOnce',
'la-dn-offerevent-sent-2Q5HQ--0',
'la-dn-offer-accepted-IDSJF',
'la-dn-offerevent-sent-PU962--0',
'la-dn-offer-accepted-9BGQV',
'la-dn-offer-data-FBKAX',
'la-dn-offerevent-sent-KPIYL--0',
'la-dn-offer-accepted-BAFKO',
'la-dn-offerevent-sent-KRVUM--1',
'la-dn-offerevent-sent-DOGVI--0',
'la-dn-offerevent-sent-BC4QG--1',
'la-dn-offer-data-A8Y5',
'la-dn-offerevent-sent-R46BC--0',
'la-dn-offer-accepted-YUWAC',
'la-dn-trigger-pages-visited-,list',
'la-dn-offer-data-NJI4C',
'la-dn-offerevent-sent-7Y6MD--0',
'la-dn-offer-data-G810U',
'la-dn-offerevent-sent-E7VPK--1',
'la-dn-offerevent-sent-BYMUK--0',
'la-dn-offer-accepted-1R98R',
'la-dn-offer-data-YQLOG',
'la-dn-offerevent-sent-0EL57--1',
'la-dn-offerevent-sent-O020Z--1',
'la-dn-offer-accepted-E61Y3',
'la-dn-offer-data-DITKF',
'la-dn-offer-data-6DO67',
'la-dn-offer-data-KENND',
'la-dn-offerevent-sent-9E1IB--0',
'la-dn-offer-data-F1SKN',
'la-dn-offer-data-JV32N',
'la-dn-offer-data-Y8DJC',
'la-dn-offer-accepted-UE5WP',
'la-dn-offer-data-WHWPY',
'la-dn-offerevent-sent-T7XIW--0',
'la-dn-offerevent-sent-CFBR2--1',
'la-dn-trigger-pages-visited',
'la-dn-offerevent-sent-FIRAM--1',
'la-dn-offer-data-SH0ZR',
'la-dn-offer-data-BAFKO',
'la-dn-offer-accepted-ZANEX',
'la-dn-offerevent-sent-HMEMI--0',
'la-dn-offer-data-BK3ZD',
'la-dn-offerevent-sent-50QDL--0',
'la-dn-offerevent-sent-JYY62--1',
'la-dn-offer-data-ITM03',
'la-dn-offer-accepted-1TA7O',
'la-dn-offerevent-sent-BN4KT--1',
'la-dn-offer-data-017ZT',
'la-dn-offerevent-sent-QF3CY--0',
'la-dn-offerevent-sent-VUOKH--0',
'la-dn-offer-accepted-X5H08',
'la-dn-offerevent-sent-U5DVZ--1',
'la-dn-offerevent-sent-C6D6L--0',
'la-dn-offerevent-sent-X7Q6O--0',
'la-dn-offer-accepted-U05OM',
'la-dn-offerevent-sent-KUKEO--0',
'la-dn-offer-data-B957Y',
'la-dn-offer-accepted-W1Q6N',
'la-dn-offerevent-sent-6DSJ--1',
'la-dn-offer-accepted-5K0D',
'la-dn-offerevent-sent-SW95A--1',
'la-dn-offerevent-sent-AOU3M--1',
'la-dn-offerevent-sent-AZIOS--1',
'la-dn-offer-accepted-I4D2H',
'la-dn-offer-accepted-GBME8',
'la-dn-offerevent-sent-GMUU7--1',
'la-dn-offerevent-sent-X41W--0',
'la-dn-offer-data-SST2W',
'la-dn-offerevent-sent-HCP6J--0',
'la-dn-offerevent-sent-IQRJA--1',
'la-dn-offerevent-sent-1R2RC--1',
'la-dn-offer-data-P3GU9',
'la-dn-offer-data-PTQE7',
'la-dn-offerevent-sent-LWVGN--1',
'la-dn-offer-accepted-POO3H',
'la-dn-offer-data-1R98R',
'la-dn-offer-accepted-MU3BT',
'la-dn-offer-accepted-2GYQ5',
'la-dn-offerevent-sent-Q3WA3--0',
'la-dn-offerevent-sent-TUCMN--0',
'la-dn-offerevent-sent-78L56--1',
'la-dn-offer-data-YLOKV',
'la-dn-offerevent-sent-65YFA--0',
'la-dn-offerevent-sent-X6GLB--1',
'la-dn-offer-data-GBME8',
'la-dn-offerevent-sent-7JB9F--1',
'la-dn-offer-data-0INVU',
'la-dn-offer-data-IDSJF',
'la-dn-offerevent-sent-CX8RI--0',
'la-dn-offerevent-sent-4SG7L--1',
'la-dn-offer-data-EIR6Q',
'la-dn-offerevent-sent-OJSG8--1',
'la-dn-offerevent-sent-SLG04--0',
'la-dn-offer-accepted-L3POW',
'la-dn-offerevent-sent-LKX4M--1',
'la-dn-offerevent-sent-YABC9--1',
'la-dn-offerevent-sent-02OCH--0',
'la-dn-offer-accepted-B69HX',
'la-dn-offer-data-9DAHD',
'la-dn-offerevent-sent-TFDGI--0',
'la-dn-offer-accepted-WHWPY',
'la-dn-offerevent-sent-BC4QG--0',
'la-dn-offer-data-YUWAC',
'la-dn-offerevent-sent-Q3WA3--1',
'la-dn-offer-accepted-PZ83J',
'la-dn-offer-data-336W9',
'la-dn-offerevent-sent-1R2RC--0',
'la-dn-offer-data-HBCQ6',
'la-dn-offer-data-X8SS4',
'la-dn-offerevent-sent-KU3D3--1',
'la-dn-offer-accepted-VPW48',
'la-dn-offerevent-sent-V1VXC--1',
'la-dn-offerevent-sent-7WLV5--1',
'la-dn-offerevent-sent-WNZTR--1',
'la-dn-trigger-exit-intent',
'la-dn-offer-accepted-HW0FW',
'la-dn-offer-data-47IMM',
'la-dn-offer-data-MDMR2',
'la-dn-offer-accepted-HCJF8',
'la-dn-offer-accepted-O7LI9',
'la-dn-offerevent-sent-QF3CY--1',
'la-dn-offer-data-NT8VY',
'la-dn-offer-accepted-SST2W',
'la-dn-offerevent-sent-IQRJA--0',
'la-dn-offer-data-FWZBF',
'la-dn-offerevent-sent-J9Y0T--1',
'la-dn-offerevent-sent-T7XIW--1',
'la-dn-offer-accepted-U6TED',
'la-dn-offerevent-sent-FWC0C--1',
'la-dn-offer-accepted-5T3JE',
'la-dn-offer-data-E87Q9',
  'la-dn-offer-data-VVT5I',
'la-dn-offer-data-CLP4D',
'la-dn-offerevent-sent-Q9A3I--0',
'la-dn-offerevent-sent-LH2ZU--0',
'la-dn-offerevent-sent-KUKEO--1',
'la-dn-offerevent-sent-H3EZV--1',
'la-dn-offerevent-sent-LWFAY--1',
'la-dn-offer-accepted-8XL6W',
'la-dn-offerevent-sent-HCP6J--1',
'la-dn-offerevent-sent-S9LPN--0',
'la-dn-offer-data-5K0D',
'la-dn-offer-accepted-AH7G1',
'la-dn-offerevent-sent-9DORU--0',
'la-dn-offerevent-sent-7IHG9--0',
'la-dn-offerevent-sent-32454--1',
'la-dn-offer-data-5RHVG',
'la-dn-offerevent-sent-1TUS1--1',
'la-dn-offer-data-8STY',
'la-dn-offer-accepted-0BGNY',
'la-dn-offer-accepted-37FW1',
'la-dn-offer-accepted-MDMR2',
'la-dn-offerevent-sent-ZJ1Q7--0',
'la-dn-offer-accepted-A8Y5',
'la-dn-offerevent-sent-2P7N2--1',
'la-dn-offerevent-sent-J5TPK--0',
'la-dn-offer-accepted-N9WN5',
'la-dn-offer-data-98D43',
'la-dn-offer-accepted-GNXQY',
'la-dn-offer-data-8FDMM',
'la-dn-offerevent-sent-Z4N4M--1',
'la-dn-offerevent-sent-LBRAT--1',
'la-dn-offer-accepted-SH0ZR',
'la-dn-offerevent-sent-SBH41--1',
'la-dn-offer-data-M4VOT',
'la-dn-offer-accepted-MBH8K',
'la-dn-offer-accepted-X13OU',
'la-dn-offer-data-T01UO',
'la-dn-offerevent-sent-KHXT1--1',
'la-dn-offer-data-EFDXS',
'la-dn-offerinfo-auto-0-37512-valid-in-session',
'la-dn-offer-accepted-PTQE7',
'la-dn-offer-accepted-NT8VY',
'la-dn-offerevent-sent-CY0LU--0',
'la-dn-offer-data-N1NWE',
'la-dn-offer-accepted-8STY',
'la-dn-offer-accepted-FFFNR',
'la-dn-offerevent-sent-91H1U--1',
'la-dn-offer-data-UE5WP',
'la-dn-offerevent-sent-YT58S--1',
'la-dn-offerevent-sent-X2Z11--1',
'la-dn-offer-accepted-T01UO',
'la-dn-offerevent-sent-X2Z11--0',
'la-dn-offer-accepted-52DOY',
'la-dn-offerevent-sent-V1VXC--0',
'la-dn-offer-data-XNK9A',
'la-dn-offer-accepted-C20GR',
'la-dn-offer-accepted-7WFQ6',
'la-dn-offerevent-sent-NCCFN--0',
'la-dn-offer-accepted-9VU9U',
'la-dn-offer-data-MBH8K',
'la-dn-offer-accepted-JGC25',
'la-dn-offerevent-sent-H2U8Z--1',
'la-dn-offerevent-sent-2GA8E--0',
'la-dn-offer-accepted-0WEQV',
'la-dn-offer-data-3TR6J',
'la-dn-offer-accepted-6453H',
'la-dn-offer-accepted-FWZBF',
'la-dn-offer-accepted-H8XLL',
'la-dn-offerevent-sent-CI6MH--1',
'la-dn-offerevent-sent-Z6552--1',
'la-dn-offerevent-sent-KU3D3--0',
'la-dn-offerevent-sent-L4ZZE--0',
'la-dn-offer-data-52DOY',
'la-dn-offerevent-sent-06492--0',
'la-dn-offerevent-sent-LBRAT--0',
'la-dn-offer-data-S0K5I',
'la-dn-offer-data-MU3BT',
'la-dn-offerevent-sent-65YFA--1',
'la-dn-offer-data-I80GW',
'la-dn-offerevent-sent-LFRTY--1',
'la-dn-offerevent-sent-BJ0E--1',
'la-dn-offerevent-sent-BJ0E--0',
'la-dn-offer-accepted-I80GW',
'la-dn-offerevent-sent-MGDY7--1',
'la-dn-offer-data-YELX7',
'la-dn-offer-data-8WLVB',
'la-dn-offer-accepted-BK3ZD',
'la-dn-offerevent-sent-RMZ84--0',
'la-dn-offerevent-sent-RD46F--1',
'la-dn-offerevent-sent-GD75S--1',
'la-dn-offerevent-sent-HQCLC--1',
'la-dn-offerevent-sent-TLOCC--0',
'la-dn-offerevent-sent-CYPW5--1',
'la-dn-offerevent-sent-PWA4L--1',
'la-dn-offerevent-sent-VNHWA--1',
'la-dn-offer-accepted-Q2IK1',
'la-dn-offerevent-sent-EI2I8--0',
'la-dn-offerevent-sent-YT58S--0',
'la-dn-offerevent-sent-AWNX--0',
'la-dn-offer-accepted-X8SS4',
'la-dn-offerevent-sent-BVK71--0',
'la-dn-offer-data-LOJZ9',
  'la-dn-offer-data-AH7G1',
'la-dn-offer-accepted-35AEB',
'la-dn-offerevent-sent-PKYQP--0',
'la-dn-offerevent-sent-S9LPN--1',
'la-dn-offer-data-8UEGG',
'la-dn-offer-accepted-3PITM',
'la-dn-offer-data-8E57K',
'la-dn-CountryInfoFromBrowsingContext',
'la-dn-offerevent-sent-CLB7E--1',
'la-dn-offerevent-sent-2P7N2--0',
'la-dn-offerevent-sent-IXZUR--0',
  'la-dn-offerevent-sent-QPH96--0',
'la-dn-offerevent-sent-3XZHO--1',
'la-dn-offer-accepted-AAT5Q',
'la-dn-offerevent-sent-HMEMI--1',
'la-dn-offerevent-sent-3MAF4--1',
'la-dn-offerevent-sent-MBCV7--1',
'la-dn-offer-accepted-QSH0M',
'la-dn-offerevent-sent-01YM6--1',
'la-dn-offerevent-sent-A5AM3--0',
'la-dn-offer-data-S7GCC',
'la-dn-offerevent-sent-MGDY7--0',
'la-dn-offer-accepted-SGLVG',
'la-dn-offer-data-GNXQY',
'la-dn-offer-accepted-1XRAB',
'la-dn-offer-data-JGC25',
'la-dn-offer-data-YDAFW',
'la-dn-offer-data-16V3Z',
'la-dn-offer-data-G1WGE',
'la-dn-offerevent-sent-JR1TQ--1',
'la-dn-offer-accepted-6DO67',
'la-dn-offer-data-D8R1V',
'la-dn-offerevent-sent-VUOKH--1',
'la-dn-offer-accepted-DITKF',
'la-dn-offerevent-sent-2Q7W--0',
'la-dn-offer-accepted-017ZT',
'la-dn-offer-data-VUEWY',
'la-dn-offer-data-NK2UH',
'la-dn-offerevent-sent-PKYQP--1',
'la-dn-offer-accepted-7PYQR',
'la-dn-OriginalReferrer',
'la-dn-offer-data-KMM2L',
'la-dn-offer-accepted-ISH7S',
'la-dn-offerevent-sent-OJSG8--0',
'la-dn-offerevent-sent-IMB1F--1',
'la-dn-offer-accepted-JV32N',
'la-dn-offerevent-sent-3MAF4--0',
'la-dn-offerevent-sent-X41W--1',
'la-dn-offerevent-sent-7PHJN--0',
'la-dn-offerevent-sent-Y57D--0',
'la-dn-offer-data-4KNC7',
'la-dn-offer-accepted-33EIF',
'la-dn-offerevent-sent-L4ZZE--1',
'la-dn-offerevent-sent-7JB9F--0',
'la-dn-offerevent-sent-R8XYV--1',
'la-dn-offerevent-sent-XJNZE--0',
'la-dn-offer-accepted-803YB',
'la-dn-offerevent-sent-T7NV8--1',
'la-dn-trigger-scroll-percentage',
'la-dn-offer-data-U6TED',
'la-dn-offer-data-1TA7O',
'la-dn-offer-accepted-MRX04',
'la-dn-offer-data-1Y8U1',
'la-dn-offerevent-sent-0EL57--0',
'la-dn-offer-accepted-16V3Z',
'la-dn-offerevent-sent-FONWE--1',
'la-dn-offer-accepted-EIR6Q',
'la-dn-offer-accepted-CES6W',
'la-dn-offer-data-ZOK74',
'la-dn-offer-accepted-KENND',
'la-dn-offer-data-JKV6Q',
'la-dn-offerevent-sent-QYZY9--0',
'la-dn-discountninjalog',
'la-dn-offer-accepted-98D43',
'la-dn-offer-accepted-LB2DC',
'la-dn-offerevent-sent-YQW6O--1',
'la-dn-offerevent-sent-GOMPL--1',
'la-dn-offerevent-sent-WZA27--0',
'la-dn-offerevent-sent-BN4KT--0',
'la-dn-offer-accepted-VVT5I',
'la-dn-offerevent-sent-BC6WR--0',
'la-dn-offer-accepted-ITM03',
'la-dn-offer-accepted-WVHW6',
'la-dn-offer-data-ZANEX',
'la-dn-offer-data-ICCTB',
'la-dn-offerevent-sent-Q9A3I--1',
'la-dn-offer-accepted-N1NWE',
'la-dn-offerevent-sent-VNHWA--0',
'la-dn-offerevent-sent-TUCMN--1',
'la-dn-offer-data-3PY65',
'la-dn-offer-accepted-ZAHQW',
'la-dn-offer-accepted-C0LWS',
'la-dn-offerevent-sent-DM5LK--0',
'la-dn-offer-accepted-3TR6J',
'la-dn-offer-data-1XRAB',
'la-dn-offerevent-sent-3XZHO--0',
'la-dn-offer-accepted-FBKAX',
'la-dn-offerevent-sent-C6D6L--1',
'la-dn-offer-accepted-YQLOG',
'la-dn-offer-data-YMSPO',
'la-dn-offer-accepted-F1SKN',
'la-dn-bucket-product-liquid',
'la-dn-bucket-product-api',
'la-dn-trigger-time-on-page',
  'la-dn-offerevent-sent-Z2M4Y--0',
'la-dn-offer-data-IUMHA',
'la-dn-offerevent-sent-PKOOT--1',
'la-dn-offerevent-sent-X6GLB--0',
'la-dn-offerevent-sent-CI6MH--0',
'la-dn-offer-accepted-VQ4ZN',
'la-dn-offer-data-33EIF',
'la-dn-offerevent-sent-H2U8Z--0',
'la-dn-offerevent-sent-UECJ7--0',
'la-dn-offer-data-L3POW',
'la-dn-offerevent-sent-02OCH--1',
'la-dn-offerevent-sent-JH60B--1',
'la-dn-offer-accepted-M4VOT',
'la-dn-offer-accepted-47IMM',
'la-dn-offer-data-HHGD6',
'la-dn-offerevent-sent-13O2A--1',
'la-dn-offerevent-sent-GMUU7--0',
'la-dn-offerevent-sent-Y57D--1',
'la-dn-offerevent-sent-CYPW5--0',
'la-dn-offer-accepted-DOTYV',
'la-dn-offerevent-sent-AZIOS--0',
'la-dn-offerevent-sent-PU962--1',
'la-dn-offer-data-Z4677',
'la-dn-offerevent-sent-H3EZV--0',
'la-dn-offer-accepted-0INVU',
'la-dn-offer-data-MRX04',
'la-dn-offer-data-T18I3',
'la-dn-offer-accepted-2S5XA',
'la-dn-offerevent-sent-3R8J3--1',
'la-dn-offerevent-sent-GQ3KL--0',
'la-dn-offer-accepted-1Y8U1',
'la-dn-offerevent-sent-U9NBC--0',
'la-dn-offer-data-JSBTM',
'la-dn-offer-data-8XL6W',
'la-dn-offer-accepted-YXEN1',
'la-dn-offerevent-sent-ET9FA--1',
'la-dn-offer-accepted-S7GCC',
'la-dn-CartValue',
'la-dn-offer-data-B69HX',
'la-dn-offer-accepted-NJI4C',
'la-dn-offerevent-sent-U5DVZ--0',
'la-dn-offerevent-sent-XS9YO--0',
'la-dn-offer-accepted-IUMHA',
'la-dn-offerevent-sent-BVK71--1',
'la-dn-offerevent-sent-Y8651--0',
'la-dn-offerevent-sent-VT3S9--0',
'la-dn-offerevent-sent-LWVGN--0',
'la-dn-offer-accepted-P3GU9',
'la-dn-offer-accepted-336W9',
'la-dn-discountninjatracing',
  'la-dn-offerevent-sent-AWNX--1',
'la-dn-offerevent-sent-6B9FC--0',
'la-dn-offer-accepted-YELX7',
'la-dn-offerevent-sent-IXZUR--1',
'la-dn-offerevent-sent-HPEDV--0',
'la-dn-offer-data-37FW1',
'la-dn-offerevent-sent-PYVEB--1',
'la-dn-offerevent-sent-GD75S--0',
'la-dn-offer-data-V9ZU2',
'la-dn-offerevent-sent-QPH96--1',
'la-dn-offerevent-sent-QTCW8--0',
'la-dn-offerevent-sent-JYY62--0',
'la-dn-offerevent-sent-ET9FA--0',
'la-dn-offer-data-803YB',
'la-dn-offer-data-SGLVG',
'la-dn-offer-accepted-3PY65',
'la-dn-offer-data-PZ83J',
'la-dn-offer-data-PHUYY',
'la-dn-offerevent-sent-Z2M4Y--1',
'la-dn-offerevent-sent-4ZFOQ--1',
'la-dn-offer-accepted-KMM2L',
'la-dn-offer-data-5T3JE',
'la-dn-offerevent-sent-U9NBC--1',
'la-dn-offer-data-H8XLL',
'la-dn-offer-data-RWG3H',
'la-dn-offer-data-5CNZ6',
'la-dn-offer-data-LJR3G',
'la-dn-offerevent-sent-KOLM8--0',
'la-dn-offerevent-sent-19RE6--1',
'la-dn-offer-data-ZMQ0R',
'la-dn-offerevent-sent-9DORU--1',
'la-dn-offer-data-VQ4ZN',
'la-dn-offer-data-X5H08',
'la-dn-offerevent-sent-FIRAM--0',
'la-dn-offer-accepted-CLP4D',
'la-dn-offerevent-sent-0QJTJ--0',
'la-dn-offerevent-sent-QYZY9--1',
'la-dn-offerevent-sent-RD46F--0',
'la-dn-offer-accepted-ZEYRB',
'la-dn-offerevent-sent-YY5Z9--1',
'la-dn-offerevent-sent-AOU3M--0',
'la-dn-offerevent-sent-XULEL--1',
'la-dn-offer-accepted-LJR3G',
'la-dn-offer-accepted-VUEWY',
'la-dn-offerevent-sent-DA0TJ--1',
'la-dn-offerevent-sent-HQCLC--0',
'la-dn-offer-accepted-29L07',
'la-dn-offer-data-ND98M',
'la-dn-offer-data-SXEBP',
'la-dn-offer-accepted-HHGD6',
'la-dn-offerevent-sent-0DSOB--0',
'la-dn-offerevent-sent-2GA8E--1',
'la-dn-offer-data-7PYQR',
'la-dn-offer-data-UYM5A',
'la-dn-offer-accepted-D35PV',
'la-dn-offer-accepted-I1YMA',
'la-dn-offer-data-2S5XA',
'la-dn-offerevent-sent-4SG7L--0',
'la-dn-offerevent-sent-1ZLY1--1',
'la-dn-offer-data-CES6W',
'la-dn-offer-accepted-G810U',
'la-dn-offerevent-sent-42JY7--1',
'la-dn-offerevent-sent-JGIYP--1',
'la-dn-offerevent-sent-DJ7ZK--1',
'la-dn-offer-data-X13OU',
'la-dn-offerevent-sent-8UYK8--0',
'la-dn-offerevent-sent-LWFAY--0',
'la-dn-offerevent-sent-6NJ2N--1',
'la-dn-offer-accepted-V042N',
'la-dn-offerevent-sent-FWC0C--0',
'la-dn-offer-accepted-SXEBP',
'la-dn-offerevent-sent-50QDL--1',
'la-dn-offer-data-ZAHQW',
'la-dn-offerevent-sent-2Q7W--1',
'la-dn-offer-accepted-9DAHD',
'la-dn-offerevent-sent-DM5LK--1',
'la-dn-offerevent-sent-HPEDV--1',
'la-dn-offer-data-L7BDX',
'la-dn-offer-data-0WEQV',
'la-dn-offerevent-sent-UTOMM--1',
'la-dn-offerevent-sent-CFBR2--0',
'la-dn-offerevent-sent-HFLJS--0',
'la-dn-offer-data-JF9D4',
'la-dn-offerevent-sent-7ZBXR--1',
'la-dn-offerevent-sent-E7VPK--0',
'la-dn-offer-accepted-YLOKV',
'la-dn-offer-accepted-JKV6Q',
'la-dn-offer-data-V042N',
'la-dn-offerevent-sent-OYUDP--1',
'la-dn-offerevent-sent-45VT--1',
'la-dn-offerevent-sent-A5AM3--1',
'la-dn-offerevent-sent-J9Y0T--0',
'la-dn-offerevent-sent-XS9YO--1',
'la-dn-offerevent-sent-CT22V--1',
'la-dn-offer-accepted-E87Q9',
'la-dn-offerevent-sent-1TUS1--0',
'la-dn-offerevent-sent-UECJ7--1',
'la-dn-offer-accepted-54C',
'la-dn-offerevent-sent-UVLC7--1',
'la-dn-offerevent-sent-PYVEB--0',
  'la-dn-offer-data-YYXX9',
'la-dn-offerevent-sent-D2DLH--1',
'la-dn-offerevent-sent-CLB7E--0',
'la-dn-offerevent-sent-GOMPL--0',
'la-dn-offerevent-sent-0QJTJ--1',
'la-dn-offerevent-sent-NCCFN--1',
'la-dn-offerevent-sent-CT22V--0',
'la-dn-offer-data-OCRM4',
'la-dn-offer-accepted-RWG3H',
'la-dn-offerevent-sent-JGIYP--0',
'la-dn-offerevent-sent-GQ3KL--1',
'la-dn-offerevent-sent-Z4N4M--0',
'la-dn-offerevent-sent-9E1IB--1',
'la-dn-offerevent-sent-T464C--0',
'la-dn-offer-accepted-YYXX9',
'la-dn-offerevent-sent-YY5Z9--0',
'la-dn-offer-data-0BGNY',
'la-dn-offer-accepted-5RHVG',
'la-dn-offer-accepted-4KNC7',
'la-dn-offerevent-sent-YQW6O--0',
'la-dn-offer-data-54C',
'la-dn-offerevent-sent-PKOOT--0',
'la-dn-offerevent-sent-BC6WR--1',
'la-dn-offer-accepted-UYM5A',
'la-dn-offerevent-sent-YABC9--0',
'la-dn-offerevent-sent-MBCV7--0',
'la-dn-offer-data-SUTE7',
'la-dn-offer-data-WVHW6',
'la-dn-offer-accepted-JSBTM',
'la-dn-offerevent-sent-HFLJS--1',
'la-dn-offerevent-sent-POMII--1',
'la-dn-offerevent-sent-8UYK8--1',
'la-dn-offer-accepted-8E57K',
'la-dn-offer-accepted-SUTE7',
'la-dn-offerevent-sent-J5TPK--1',
'la-dn-offerevent-sent-19RE6--0',
'la-dn-offer-data-SCZ6S',
'la-dn-offerinfo-requested-auto-0-37512',
'la-dn-fallback-to-draft-order',
'la-dn-offer-data-W1Q6N'];
for(var x= 0;x<session_vlaues.length;x++){
  removeSessionStorageItem(session_vlaues[x]);  
}
/****************************** remove sessionstorage end  ********************/
/****************************** removel Cookies start  ******************/
 function removeCookiesItem(key) {
    setTimeout(function () {
      if (Cookies.get(key)) {
        Cookies.remove(key);
        console.log(`Removed '${key}' from Cookies.`);
      } else {
       console.log(`No item with key '${key}' found in Cookies.`);
      }
    }, 5000);
  }
removeCookiesItem('_li_dcdm_c');
/****************************** remove cookies end  ******************/
function setCookieNew(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookieNew(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// scroll down to section for pages in shogun
$(document).ready(function () {
$('.scroll-first').on('click', function() {
        var currentSection = $(window).scrollTop();
        var nextSection = $('#method').filter(function() {
            return $(this).offset().top > currentSection;
        }).first();

        if (nextSection.length > 0) {
            $('html, body').animate({
                scrollTop: nextSection.offset().top
            }, 500, 'linear'); 
        }
    });
  $('.scroll-second').on('click', function() {
        var currentSection = $(window).scrollTop();
        var nextSection = $('#method2').filter(function() {
            return $(this).offset().top > currentSection;
        }).first();

        if (nextSection.length > 0) {
            $('html, body').animate({
                scrollTop: nextSection.offset().top
            }, 500, 'linear'); 
        }
    });
 $('.scroll-third').on('click', function() {
    var currentSection = $(window).scrollTop(); 
    var nextSection = $('#method3').filter(function() {
        return $(this).offset().top > currentSection;
    }).first();

    if (nextSection.length > 0) {
        $('html, body').animate({
            scrollTop: nextSection.offset().top
        }, 500, 'linear');  
    }
});
  $('.scroll-forth').on('click', function() {
        var currentSection = $(window).scrollTop();
        var nextSection = $('#method4').filter(function() {
            return $(this).offset().top > currentSection;
        }).first();

        if (nextSection.length > 0) {
            $('html, body').animate({
                scrollTop: nextSection.offset().top
            }, 500, 'linear'); 
        }
    });

});
// scroll down to section for pages in shogun
$('button[rv-data-balloon="model.lang.close_tip"]').click(function() {
console.log('consoleing data');
  const event = new CustomEvent('optimonkcampaign'); 
  document.dispatchEvent(event);
});
//custom js search bar
$(document).ready(function() {
    $('.mobile-search-icon').on('click', function(event) {
             event.preventDefault();
        $('.live-search').toggle(); 
    });
$(window).resize(function() {
    if (window.Searchanise && typeof window.Searchanise.Init === 'function') {
    window.Searchanise.Init();
  }
});
});
 $('.table-content-wrapper .table-content-item1').on('click', function() {
        var currentSection1 = $(window).scrollTop();
        var nextSection1 = $('.purchase-order-jtpl').filter(function() {
            return $(this).offset().top > currentSection1;
        }).first();

        if (nextSection1.length > 0) {
            $('html, body').animate({
                scrollTop: nextSection1.offset().top - 170 
            }, 500, 'linear'); 
        }
    });
  $('.table-content-wrapper .table-content-item2').on('click', function() {
        var currentSection2 = $(window).scrollTop();
        var nextSection2 = $('.budget-friendly-jtpl').filter(function() {
            return $(this).offset().top > currentSection2;
        }).first();

        if (nextSection2.length > 0) {
            $('html, body').animate({
                scrollTop: nextSection2.offset().top - 120 
            }, 500, 'linear'); 
        }
    });
  $('.table-content-wrapper .table-content-item3').on('click', function() {
        var currentSection3 = $(window).scrollTop();
        var nextSection3 = $('.sustainable-cleaning-sec').filter(function() {
            return $(this).offset().top > currentSection3;
        }).first();

        if (nextSection3.length > 0) {
            $('html, body').animate({
                scrollTop: nextSection3.offset().top - 120
            }, 500, 'linear'); 
        }
    });
$('.table-content-wrapper .table-content-item4').on('click', function() {
      var currentSection4 = $(window).scrollTop();
      var nextSection4 = $('.high-traffic-areas-jtpl').filter(function() {
          return $(this).offset().top > currentSection4;
      }).first();

      if (nextSection4.length > 0) {
          $('html, body').animate({
              scrollTop: nextSection4.offset().top - 120 
          }, 500, 'linear'); 
      }
  });
$('.table-content-wrapper .table-content-item5').on('click', function() {
  var currentSection5 = $(window).scrollTop();
  var nextSection5 = $('.bulk-stocking-jtpl').filter(function() {
      return $(this).offset().top > currentSection5;
  }).first();

  if (nextSection5.length > 0) {
      $('html, body').animate({
          scrollTop: nextSection5.offset().top - 120 
      }, 500, 'linear'); 
  }
}); 
$('.table-content-wrapper .table-content-item6').on('click', function() {
  var currentSection6 = $(window).scrollTop();
  var nextSection6 = $('.customer-support-jtpl').filter(function() {
      return $(this).offset().top > currentSection6;
  }).first();

  if (nextSection6.length > 0) {
      $('html, body').animate({
          scrollTop: nextSection6.offset().top - 120 
      }, 500, 'linear'); 
  }
});

$('.table-content-wrapper .table-content-item7').on('click', function() {
  var currentSection7 = $(window).scrollTop();
  var nextSection7 = $('.lifespan').filter(function() {
      return $(this).offset().top > currentSection7;
  }).first();

  if (nextSection7.length > 0) {
      $('html, body').animate({
          scrollTop: nextSection7.offset().top - 120 
      }, 500, 'linear'); 
  }
});

$('.table-content-wrapper .table-content-item8').on('click', function() {
  var currentSection8 = $(window).scrollTop();
  var nextSection8 = $('.best-sellers-sec').filter(function() {
      return $(this).offset().top > currentSection8;
  }).first();

  if (nextSection8.length > 0) {
      $('html, body').animate({
          scrollTop: nextSection8.offset().top - 120 
      }, 500, 'linear'); 
  }
});
$('.table-content-wrapper .table-content-item9').on('click', function() {
  var currentSection9 = $(window).scrollTop();
  var nextSection9 = $('.contact-us-sec').filter(function() {
      return $(this).offset().top > currentSection9;
  }).first();

  if (nextSection9.length > 0) {
      $('html, body').animate({
          scrollTop: nextSection9.offset().top - 120 
      }, 500, 'linear'); 
  }
});

// Residential Cleaning page js
$('.table-content-wrapper .table-content-item-4').on('click', function() {
      var currentSection4 = $(window).scrollTop();
      var nextSection4 = $('.cstmsustain.sustainable-cleaning-sec').filter(function() {
          return $(this).offset().top > currentSection4;
      }).first();

      if (nextSection4.length > 0) {
          $('html, body').animate({
              scrollTop: nextSection4.offset().top - 120 
          }, 500, 'linear'); 
      }
  });
$('.table-content-wrapper .table-content-item-9').on('click', function() {
  var currentSection8 = $(window).scrollTop();
  var nextSection8 = $('.contact-us-sec-1').filter(function() {
      return $(this).offset().top > currentSection8;
  }).first();

  if (nextSection8.length > 0) {
      $('html, body').animate({
          scrollTop: nextSection8.offset().top - 120 
      }, 500, 'linear'); 
  }
});
$('.table-content-wrapper .column-revers-11-jtpl').on('click', function() {
  var currentSection6 = $(window).scrollTop();
  var nextSection6 = $('.column-revers-11').filter(function() {
      return $(this).offset().top > currentSection6;
  }).first();

  if (nextSection6.length > 0) {
      $('html, body').animate({
          scrollTop: nextSection6.offset().top - 120 
      }, 500, 'linear'); 
  }
});
$('.table-content-wrapper .contact-us-sec-jtpl').on('click', function() {
  var currentSection6 = $(window).scrollTop();
  var nextSection6 = $('.contact-us-sec ').filter(function() {
      return $(this).offset().top > currentSection6;
  }).first();
  if (nextSection6.length > 0) {
      $('html, body').animate({
          scrollTop: nextSection6.offset().top - 120 
      }, 500, 'linear'); 
  }
});
$('.live-chat-jtpl').click(function(){
    GorgiasChat.open();
});
$(document).ready(function() {
    $('.anchor-tag ').click(function() {
        window.location.href = "tel:+18777916677"; 
    });
});
//sogun Page title pass in input
if ($('input[name="Page Title"]').length > 0) {
var url = window.location.href;  
var handle = url.split('/').pop(); 
    $('input[name="Page Title"]').val(handle);
    $('input[name="Page Title"]').closest('.page-type-jtpl').hide();
}
$(document).ready(function() {
  $('.custom-ready-contact .shogun-form-box-submit').click(function() {
    setTimeout(function() {
      // Check if the button is disabled and if the custom-ready class exists
      if ($('.custom-ready-contact .shogun-form-box-submit').is(':disabled')) {
        $('.custom-thank-masssage').hide(); // Hide thank you message
        $('.append-content-thank').append(
          '<div class="form-thanku-msg">' +
            '<img style="display: block;-webkit-user-select: none;margin: auto;" src="https://s3-alpha-sig.figma.com/img/8eda/598b/b0231969a9033ef2208d09ddff46a744?Expires=1742774400&amp;Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&amp;Signature=bpvfeBoWl5fK~RNxH0bEBbGBRgsRlSjtKpC6bjbriz6ERyBNyZXb4X~VxT4CywKMOuC3iLDAMnEwiRdrCZHZBzPo7B0kLAUUahqo4GCtmv7El1tY4vZwOnVSbjcSpuXHMKo-jCc~57ny2RMS~hmShZytCUaxwXdTTq~97SwQt38IosMA-oBEKZCzTWewna0DtwEOHybGHBqzVhqahm2t-Nc3Tc~lN6qiECtj-cR2mO18MrkEPH-fZSFdW4ZxvihQL6I9LTMmdcIDPkEfGc9U2wLvzcxI9WCRSSNeZDAdfX5Y7zqN6j7iU44O1O5Y0tpR4aN5BjDKV2diCnojMhjC7A__">' +
            '<h4>Thank You For Applying!</h4>' +
            '<p>Once we’ve reviewed your profile we’ll send you an email to let you know if you’ve been approved.</p>' +
          '</div>'
        );
      }
    }, 2000); // 2000ms = 2 seconds
  });
});
//free shipping bar:- 
$(document).on('click','.product-form--atc-button',function(){
     $.ajax({
      url: "/cart.json",
      type: "GET",
      dataType: "json",
      success: function (cart) {
        console.log("hereweare", cart);
        var carttotalprice = parseFloat(cart.total_price / 100).toFixed(2);
        $('.total-custom-price').text(carttotalprice);
         console.log("====================================hereweare",carttotalprice );
        var $cartCount = $(
          ".site-header--traditional .site-header-cart-button .site-header-icon .site-header-cart--count"
        );
        var $headerCartCount = $(
          ".site-header--traditional .header-cart-count[data-header-cart-count-2]"
        );
        var $headerCartTotal = $(
          ".site-header--traditional .header-cart-total[data-header-cart-total]"
        );
        console.log("Updated cart item count:", cart.item_count);
        console.log("cartcount:", $cartCount.html());
        if (cart.item_count > 0) {
          $cartCount.attr("data-header-cart-count", cart.item_count);
          $cartCount.addClass("visible");
          $cartCount.html("");
          $headerCartCount.html(cart.item_count);
          var formattedTotal = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(cart.total_price / 100);
          $headerCartTotal.html(formattedTotal);
        } else {
          $cartCount.removeClass("visible");
          $cartCount.html("");
          $headerCartCount.html("0");
          $headerCartTotal.html("$0.00");
        }
      $.ajax({
      url: "/cart",
      type: "GET",
      dataType: "html",
      success: function (cart) {
        console.log("cart!!!!!!!!!!");
        $(".free-shiping-custom").html($(cart).find(".free-shiping-custom").html());
      }
        });
      },
      error: function (xhr, status, error) {
        console.error("Error fetching cart:", status, error);
      },
    });
});
 $(document).on("click", ".custom-minus", function () { 
        var quantity = $(".js-qty__num-jtpl").val();
               //  alert(quantity);
             if( quantity <= 1 ){
      }else{
        //   var cartItemsContainer = document.querySelector(".remove-pro");
        // var loaderHtml = `<div class="loader"></div>`;
        // cartItemsContainer.innerHTML = loaderHtml;
      }
 });
$(document).on("click", ".custom-plus", function () {    
        // var cartItemsContainer = document.querySelector(".remove-pro");
        // var loaderHtml = `<div class="loader"></div>`;
        // cartItemsContainer.innerHTML = loaderHtml; 
});
   $(document).on('click', '.qty-btn', function () {
    const $input = $(this).siblings('.qty-input');
    let currentVal = parseInt($input.val());
    // Fallback if currentVal is not a number
    if (isNaN(currentVal)) currentVal = 1;
    if ($(this).hasClass('qty-plus')) {
      $input.val(currentVal + 1);
    } else if ($(this).hasClass('qty-minus')) {
      if (currentVal > 1) {
        $input.val(currentVal - 1);
      }
    }
  });
//submit button click remove reload js
 $(document).ready(function() {
    $('.shg-btn.shg-cse.shogun-form-box-submit').on('click', function(e) {
        if (!$(this).is('[disabled]')) {
            e.preventDefault();
            e.stopPropagation();
        }
    });
  if($('.about-us-video').length > 0){
    var $iframe = $('.about-us-video .shogun-video-embed');
    var src = $iframe.attr('src');
    var newSrc = updateQueryStringParameter(src, 'controls', '0');
    $iframe.attr('src', newSrc);
    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    }
  }
//blog scroll trigger
  $('.blog-anchor-tag a[href]').on('click', function (e) {
      // e.preventDefault();
        var className = $(this).attr('href').replace(/^\./, '').replace(/^\//, ''); 
        var $target = $('.' + className); 
        if ($target.length) {
            e.preventDefault(); 
          let scrollval = $target.offset().top - 122;
            $('html, body').animate({
                scrollTop: scrollval
            }, 800);
        }
    });
    if($("body").hasClass("template-collection")){
      const loadIntelligems = () => {
        if (window.intelligemsLoaded) return;
        window.intelligemsLoaded = true;
    
        const script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://cdn.intelligems.io/esm/b71de474c205/bundle.js';
        document.head.appendChild(script);
    
        console.log('Intelligems script loaded');
      };
    
      ['click', 'scroll', 'keydown', 'mousemove'].forEach(event => {
        window.addEventListener(event, loadIntelligems, { once: true });
      });
    }
});
(function waitForIframeInWrapper() {
    const wrapper = document.getElementById("PBarNextFrameWrapper");
    if (wrapper) {
      const iframe = wrapper.querySelector("#PBarNextFrame");
      if (iframe) {
        iframe.setAttribute("title", "myFrame");
      } else {
        setTimeout(waitForIframeInWrapper, 300);
      }
    } else {
      setTimeout(waitForIframeInWrapper, 300);
    }
  })();